define(['angular', 'moment'], function (angular, moment) {


    // TODO offre de fidélité

    /**
     * @class PricesService
     */
    function PricesService(
        $rootScope,
        $log,
        orderService,
        marketService,
        tillPackService,
        boulangerieService,
        goodwillGesturesService,
        marginService,
        napService,
        offerService,
        promotionService,
        commonService
    ) {
        var self = this;

        var _orderForm, _order;

        var _isScanupRental = false;
        var _isFlashupRental = false;
        let _isInstallRental = false;
        let _isCateringSupportRental = false;

        // Taux et constantes
        // Taux leasing caisse a utiliser pour le calcul PROFORMA
        var TRAD_LEASER_LOC36 = 0.03024;
        var TRAD_LEASER_LOC48 = 0.02332;
        var TRAD_LEASER_LOC60 = 0.01919;
        var TRAD_LEASER_ACHAT = 0.03024;

         self.RENTAL_LEASER = {
            36:    0.03024,
            37:    0.0295,
            38:    0.0288,
            39:    0.0281,
            40:    0.0275,
            41:    0.0269,
            42:    0.0263,
            43:    0.0257,
            44:    0.0252,
            45:    0.0247,
            46:    0.0242,
            47:    0.0238,
            48:    0.02332,
            49:    0.02290,
            50:    0.02249,
            51:    0.02210,
            52:    0.02173,
            53:    0.02137,
            54:    0.02102,
            55:    0.02069,
            56:    0.02037,
            57:    0.02006,
            58:    0.01976,
            59:    0.01947,
            60:    0.01919,
        }

        // Taux leasing réintégration: identiques aux taux leasing caisses (en trad)
        var TRAD_LEASER_REINTEGRATION_LOC36 = 0.03024;
        var TRAD_LEASER_REINTEGRATION_LOC48 = 0.02332; // anciennement 0.02381
        var TRAD_LEASER_REINTEGRATION_LOC60 = 0.01919; // anciennement 0.01981
        var NAP_LEASER_REINTEGRATION_LOW = 0.02538;
        var NAP_LEASER_REINTEGRATION_HIGH = 0.02425;

        /* Taux de réduction pour le calcul du prix des options à l'achat (accessoires caisses, imprimante, tiroirs)*/
        var TAUX_OPTIONS_ACHAT = 0.95;

        /* TVA 20%*/
        var TVA_20 = 0.2;

        function purchaseOptionsRateCondition() {
            return (
                _order.contract.contractType.code === 'ACHAT' &&
                offerService.isOlderOffer(_order) === true &&
                _isNAP() === false
            );
        }

        /* Taux de dégressivité des tarifs en fonction du nombre de caisses ou d'articles*/
        var TABACPRESSE_TAUX_DEGRESSIFS = {
            1: 0,
            2: 0.15,
            3: 0.2,
            4: 0.25,
            5: 0.3,
            6: 0.35,
        };

        // utilisés pour l'offre 2017
        var BOULANGERIE_TAUX_DEGRESSIFS = {
            1: 0,
            2: 0.1,
            3: 0.15,
            4: 0.2,
            5: 0.25
        };

        const DELOITTE_MAX_AMOUNT = 9000; // 4500 € max
        const DELOITTE_PERCENT_SUBVENTION = 0.7; // 40%

        function _isCateringSupport(code) {
            return ['RESTAURATION-ESSENTIEL', 'RESTAURATION-PREMIUM', 'RESTAURATION-ULTIMATE'].indexOf(code) !== -1;
        }

        /* Get const values  */

        /**
         * Get the appropriate degressive rate according to the order and custom rate possibility.
         * @param  {Object} order
         * @param  {Number} amount
         * @param  {Boolean} canBeCustomRate
         */
        self.getDegressiveRate = function getDegressiveRate(order, amount, canBeCustomRate) {
            if (canBeCustomRate && order.isMultiStores === true) {
                return _getCustomDegressiveRate(order);
            } else {
                return _getAmountDegressiveRate(order.marketType.code, amount);
            }
        };

        /**
         * Get normal degressive rate based on the order market
         * @param  {String} market
         * @param  {Number} amount
         * @return {Number} rate percentage of the price that will be discounted
         */
        function _getAmountDegressiveRate(marketCode, amount) {
            if (amount === 0) {
                return 0;
            }
            if (amount > 6) {
                amount = 6;
            }
            if (marketCode === 'TABACPRESSE' || marketCode === 'AUTRE' || marketCode === 'FLEURISTE') {
                return TABACPRESSE_TAUX_DEGRESSIFS[amount];
            } else if (marketCode === 'BOULANGERIE') {
                // Boulangerie market uses the same degressive rate than tabacpresse for newer offers
                if (offerService.isOlderOffer(_order) === true) {
                    return BOULANGERIE_TAUX_DEGRESSIFS[amount];
                } else {
                    return TABACPRESSE_TAUX_DEGRESSIFS[amount];
                }
            }
            return 0;
        }

        /**
         * Get order degressive custom rate
         * @param  {Object} order
         * @return {Number}       rate
         */
        function _getCustomDegressiveRate(order) {
            if (!order.storesGroup || !order.storesGroup.rate) {
                return 0;
            } // No custom rate to apply
            return order.storesGroup.rate / 100;
        }

        self.getLeaserRate = function () {
            switch (_order.contract.contractType.code) {
                case 'LOC36':
                    return TRAD_LEASER_LOC36;
                case 'LOC48':
                    return TRAD_LEASER_LOC48;
                case 'LOC60':
                    return TRAD_LEASER_LOC60;
                case 'ACHAT':
                    return TRAD_LEASER_ACHAT;
                default:
                    return 1;
            }
        };

        self.getAmountFinanced = () => {
            return (_order.contract.nbMonthsFidelity * _order.contract.monthlyPaymentFidelity + orderService.getContractMonths(_order) * _order.prices.leaserSubtotal)
                / (orderService.getContractMonths(_order) + _order.contract.nbMonthsFidelity);
        }

        /* Formulas for price calculation, where precision is the number of decimals wanted */
        self.applyDegressiveRate = function applyDegressiveRate(price, rate, precision, round) {
            round = round === undefined ? true : round;
            if (offerService.isOlderOffer(_order) === true || _isNAP()) {
                return Math.ceil(price * (1 - rate));
            } else {
                var precisionFactor = precision ? Math.pow(10, precision) : 1;
                // Arrondi classique sur la nouvelle offre 2018
                if (round) {
                    return Math.round(price * (1 - rate) * precisionFactor) / precisionFactor;
                }
                return (price * (1 - rate) * precisionFactor) / precisionFactor;
            }
        };

        self.applyDiscountRate = function applyDiscountRate(discount) {
            return 1 - discount / 100;
        };

        self.calculateDiscount = function calculateDiscount(price, discount) {
            return price * (discount / 100);
        };

        self.priceConverter = (price) => {
            const rate = self.getLeaserRate();
            const nbTills = orderService.getNbTills(_order.tills);
            const degressiveRate = self.getDegressiveRate(_order, nbTills);
            const upFrontPrice = price / TRAD_LEASER_LOC48;
            if(_order.contract.contractType.code === 'ACHAT' && nbTills === 1)
                return Math.ceil(upFrontPrice);
            if(_order.contract.contractType.code === 'ACHAT' && nbTills > 1)
                return Math.ceil(upFrontPrice * nbTills * (1 - degressiveRate));
            if(nbTills === 1)
                return Math.ceil(upFrontPrice * rate);
            return Math.ceil(upFrontPrice * rate * nbTills * (1 - degressiveRate));
        }
        /**
         * Find the right price for an option according to the given contract type and possibly a marketType
         * @param  {Array} prices
         * @param  {String} contractTypeCode 'LOC36', 'LOC48', 'LOC60', 'ACHAT'
         * @param  {String} marketTypeCode one the existing market strings. Facultative argument
         * @param  {Number} nbTills
         * @return {Object} price
         */
        self.getOptionUnitPriceByTills = function (prices, contractTypeCode, marketTypeCode, nbTills) {
            nbTills = nbTills ? nbTills : 1;
            if (marketTypeCode) {
                return prices.find(function (price) {
                    return price.type.code === contractTypeCode && price.nbTills === nbTills && price.marketType.code === marketTypeCode;
                });
            } else {
                return prices.find(function (price) {
                    return price.type.code === contractTypeCode && price.nbTills === nbTills;
                });
            }
        };

        /**
         * Find the right price for an option according to the given contract type and possibly a marketType
         * @param  {Array} prices
         * @param  {String} contractTypeCode 'LOC36', 'LOC48', 'LOC60', 'ACHAT'
         * @param  {String} marketTypeCode one the existing market strings. Facultative argument
         * @return {Object} price
         */
        self.getUnitPrice = function (prices, contractTypeCode, marketTypeCode) {
            if (marketTypeCode) {
                return prices.find(function (price) {
                    return price.type.code === contractTypeCode && price.marketType.code === marketTypeCode;
                });
            } else {
                return prices.find(function (price) {
                    return price.type.code === contractTypeCode;
                });
            }
        };

        /**
         * Price calculation for till accessories options
         * @param  {Number} price correct price's value
         * @param  {Number} amount amount of accessories
         * @return {Number}
         */
        self.getTillAccessoriesPrice = function getTillAccessoriesPrice(price, amount) {
            if (purchaseOptionsRateCondition() === true) {
                return Math.round(price * TAUX_OPTIONS_ACHAT * amount);
            } else {
                return price * amount;
            }
        };

        self.getOptionUnitPrice = function getOptionUnitPrice(option, isAdditional, round) {
            if (option === null) {
                return;
            }

            var contractTypeCode = _order.contract.contractType.code;
            var nbTills = orderService.getNbTills(_order.tills);
            let priceNbTills = option.isDependNbTills ? nbTills : 1;
            var tillsMultiplier = 1; // Used for options where the number of tills are used in the unit price
            var degressiveRate = offerService.isOlderOffer(_order) === false; // Mandatory deggressive prices on 2018 offer
            var isTillsDegressiveRate = false; // uses tills amount for degressive rate. If false, it uses the option amount
            var roundingPrecision = 0;
            var isRoundingBeforeAmount = false; // Does the deggressive rate and rounding formula is applied before multiplying by option amount or after
            var canBeCustomRate = false;
            round = typeof round !== 'undefined' ? round : false;

            // Imprimante supplémentaire

            if (option.optionType.code === 'IMPRIMANTE' && option.isAdditional) {
                contractTypeCode = 'SUP';
            }
            // Scanup & PRESTATION: contrat spécifique
            if (option.optionType.code === 'SCANUP') {
                contractTypeCode =
                    _order.scanupContractType !== undefined
                        ? _order.scanupContractType.code
                        : _order.contract.contractType.code;
            }
            if (option.optionType.code === 'PRESTATION' && ['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(option.code)) {
                contractTypeCode =
                    _order.installContractType !== undefined
                        ? _order.installContractType.code
                        : _order.contract.contractType.code;
            }

            if (option.optionType.code === 'PRESTATION' /*&& _isCateringSupport(option.code)*/) {
                contractTypeCode =
                    _order.cateringSupportContractType !== undefined
                        ? _order.cateringSupportContractType.code
                        : _order.contract.contractType.code;
            }

            // Accessoires caisse, exception spécifique à l'achat
            if (option.optionType.code === 'ACCESSOIRE_CAISSE') {
                if (
                    _isRental() === false &&
                    offerService.isOlderOffer(_order) === true &&
                    (_isTRAD() || _isFLORAJET())
                ) {
                    // On divise par le nombre de caisse pour récupérer le prix unitaire et éviter un souci d'arrondi lié à la réduction avec TAUX_OPTIONS_ACHAT
                    return (
                        self.getTillAccessoriesPrice(
                            self.getOptionUnitPriceByTills(option.prices, contractTypeCode, _order.marketType.code, priceNbTills).value,
                            nbTills
                        ) / nbTills
                    );
                }
                canBeCustomRate = true;
            }
            // SAV, maintenance

            if (option.optionType.code === 'SAV' || option.optionType.code === 'MAINTENANCE') {
                contractTypeCode = contractTypeCode === 'ACHAT' ? 'LOC48' : contractTypeCode;
                tillsMultiplier = nbTills;
                degressiveRate = true;
                isTillsDegressiveRate = true;
                round = true;
                // Special rounding with one decimal for maintenance pack
                if (offerService.isOlderOffer(_order) === false && option.optionType.code === 'MAINTENANCE') {
                    roundingPrecision = 1;
                    isRoundingBeforeAmount = true;
                }
            }
            // Extension de garantie
            if (option.optionType.code === 'EXTENSION') {
                if (offerService.isOlderOffer(_order) === true) {
                    contractTypeCode = contractTypeCode === 'ACHAT' ? 'LOC48' : contractTypeCode;
                }
                tillsMultiplier = nbTills;
                degressiveRate = true;
                isTillsDegressiveRate = true;
            }
            // Packs boulangerie
            if (option.optionType.code === 'PACK_BOULANGERIE') {
                tillsMultiplier = nbTills;
                degressiveRate = true;
                round = true
            }
            // Logiciels
            if (option.optionType.code === 'LOGICIEL_CAISSE') {
                tillsMultiplier = option.code === 'RESTAURATION-COUPLE' || option.code === 'PACK-MPDV-PILOTAGE' ? option.nbOptions : nbTills;
                degressiveRate = true;
                isTillsDegressiveRate = option.code === 'RESTAURATION-COUPLE' || option.code === 'PACK-MPDV-PILOTAGE' ? false : true;
                canBeCustomRate = true;
                round = true
            }
            // Defaut options
            if (option.optionType.code === 'DEFAUT') {
                canBeCustomRate = true;
            }
            // Options TPE et monétiques
            if (option.optionType.code === 'LOGICIEL' || (option.optionType.code === 'TPE' && !option.isTPEDevice)) {
                contractTypeCode = 'ACHAT';
                degressiveRate = false;
            }
            // TPE devices
            if (option.optionType.code === 'TPE' && option.isTPEDevice === true) {
                contractTypeCode = _isRental() ? _order.contract.contractType.code : 'LOC48';
                degressiveRate = false;
            }
            // TPE Bluetooth Option supp
            if (
                option.optionType.code === 'TPE' &&
                option.isTPEDevice === true &&
                option.isDefault === false &&
                isAdditional === true
            ) {
                contractTypeCode = 'ACHAT';
                degressiveRate = false;
            }
            // Frais activation B Booster
            if (option.optionType.code === 'OPTSANSENG' && option.code === 'B-BOOSTER') {
                contractTypeCode = 'ACHAT';
                degressiveRate = false;
            }

            if (degressiveRate) {
                // 2018 Offer
                if (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET())) {
                    var degressiveRateAmount = isTillsDegressiveRate ? nbTills : option.nbOptions;
                    if (isRoundingBeforeAmount === true) {
                        return self.applyDegressiveRate(
                            self.getOptionUnitPriceByTills(option.prices, contractTypeCode, _order.marketType.code, priceNbTills).value *
                            tillsMultiplier,
                            self.getDegressiveRate(_order, degressiveRateAmount, canBeCustomRate),
                            roundingPrecision,
                            round
                        );
                    } else {
                        return (
                            self.applyDegressiveRate(
                                self.getOptionUnitPriceByTills(option.prices, contractTypeCode, _order.marketType.code, priceNbTills).value,
                                self.getDegressiveRate(_order, degressiveRateAmount, canBeCustomRate),
                                roundingPrecision,
                                round
                            ) * tillsMultiplier
                        );
                    }
                    // Older offers
                } else {
                    return self.applyDegressiveRate(
                        self.getOptionUnitPriceByTills(option.prices, contractTypeCode, _order.marketType.code, priceNbTills).value *
                        tillsMultiplier,
                        self.getDegressiveRate(_order, nbTills)
                    );
                }
            } else {
                return (
                    self.getOptionUnitPriceByTills(option.prices, contractTypeCode, _order.marketType.code, priceNbTills).value * tillsMultiplier
                );
            }
        };

        /**
         * Sum a given array of prices
         * @param  {Array} prices  array of number to sum
         * @param  {Number} accumulator Starting amount to add to the array's sum
         * @return {Number} total price sum array + accumulator
         */
        self.sumPrices = function sumPrices(prices, accumulator) {
            return prices.reduce(function (acc, price) {
                return acc + price;
            }, accumulator || 0);
        };

        /**
         * Set the order form data
         * @param {Object} orderForm
         */
        self.setOrderForm = function setOrderForm(orderForm) {
            _orderForm = orderForm;
        };

        /**
         * Set the order model
         * @param {Object} order
         */
        self.setOrder = function setOrder(order) {
            _order = order;
            _initOrderTillsAndOptionsPrices();
        };

        /**
         * Determine if the order has the extension scenario
         * @return {Boolean}
         */
        function _isExtensionScenario() {
            return _order.contract.scenarioType.code === 'EXTENSION';
        }

        /**
         * Determine if the order has a rental contract
         * @return {Boolean}
         */
        function _isRental() {
            return orderService.isRental(_order.contract.contractType.code);
        }

        /**
         * Get the numerical value for the rental contract type
         * @return {Number}
         */
        self.getContractTypeValue = function getContractTypeValue() {
            return _order.contract.contractType.code === 'LOC48'
                ? 48
                : _order.contract.contractType.code === 'LOC60'
                    ? 60
                    : _order.contract.contractType.code === 'LOC36'
                        ? 36
                        : 1;
        };

        /**
         * Determine if the order belongs to the NAP network
         * @return {Boolean}
         */
        function _isNAP() {
            return _order.orderType.code === 'NAP';
        }

        function _isTRAD() {
            return _order.orderType.code === 'TRAD';
        }

        function _isFLORAJET() {
            return _order.orderType.code === 'FLORAJET';
        }

        /**
         * Init the options and tills arrays in order model
         */
        function _initOrderTillsAndOptionsPrices() {
            var nb, nbOptions, contractType, nbOffered, isSpaceVerified, identifiersX3;

            for (var i = 0; i < _order.tills.length; i++) {
                for (var j = 0; j < _orderForm.tills.length; j++) {
                    if (_order.tills[i].id === _orderForm.tills[j].id) {
                        nb = _order.tills[i].nbTills;
                        identifiersX3 = _order.tills[i].identifiersX3;
                        isSpaceVerified = _order.tills[i].isSpaceVerified || false;
                        _order.tills[i] = _orderForm.tills[j];
                        _order.tills[i].nbTills = nb;
                        _order.tills[i].identifiersX3 = identifiersX3;
                        _order.tills[i].isSpaceVerified = isSpaceVerified;
                        break;
                    }
                }
            }

            for (var i = 0; i < _order.options.length; i++) {
                for (var j = 0; j < _orderForm.options.length; j++) {
                    if (_order.options[i].id === _orderForm.options[j].id) {
                        nb = _order.options[i].nbOptions;
                        identifiersX3 = _order.options[i].identifiersX3;
                        contractType = _order.options[i].contractType;
                        nbOffered = _order.options[i].nbOffered;
                        isSpaceVerified = _order.options[i].isSpaceVerified || false;
                        _order.options[i] = _orderForm.options[j];
                        _order.options[i].nbOptions = nb;
                        _order.options[i].contractType = contractType;
                        _order.options[i].nbOffered = nbOffered;
                        _order.options[i].identifiersX3 = identifiersX3;
                        _order.options[i].isSpaceVerified = isSpaceVerified;
                        _order.options[i].isAdditional = false;
                        _order.options[i].discount = orderService.getDiscountValue(_order.options[i]);
                        break;
                    }
                }
            }

            for (var i = 0; i < _order.cashDrawers.length; i++) {
                for (var j = 0; j < _orderForm.cashDrawers.length; j++) {
                    if (_order.cashDrawers[i].id === _orderForm.cashDrawers[j].id) {
                        nb = _order.cashDrawers[i].nbCashDrawers;
                        identifiersX3 = _order.cashDrawers[i].identifiersX3;
                        isSpaceVerified = _order.cashDrawers[i].isSpaceVerified || false;
                        _order.cashDrawers[i] = _orderForm.cashDrawers[j];
                        _order.cashDrawers[i].nbCashDrawers = nb;
                        _order.cashDrawers[i].identifiersX3 = identifiersX3;
                        _order.cashDrawers[i].isSpaceVerified = isSpaceVerified;
                        break;
                    }
                }
            }

            _order.promotions = promotionService.mapOrderFormData(_order.promotions, _orderForm.promotions);

            self.updateOrderPrices();
        }

        /**
         * Update the prices' order model
         */
        self.updateOrderPrices = function updateOrderPrices() {
            var printer, BBooster;
            var maintenancePrice = 0,
                savPrice = 0,
                extensionPrice = 0;
            var tillAmount = orderService.getNbTills(_order.tills);

            _order.prices.proformaDetails = {};
            _order.prices.servicesNAP = 0;

            if (_isNAP()) {
                var contractTypeNAP = _isRental() ? 'rental' : 'purchase';
                var till = self.calculateTillPricesNAP(_order.contract.contractType.code);
                printer = self.calculatePrinterPricesNAP();
                var scanup = self.calculateScanupPricesNAP();
                var tabletAndPC = self.calculateDefaultOptionsPricesNAP();
                _order.prices.till = till[contractTypeNAP];
                var tpe = self.calculateTPEPricesNAP();
                var tillAccessoriesPrice = self.calculateTillAccessoriesPricesNAP();
                var cashDrawersPrice = self.calculateCashDrawersPrices();
                let gestionPrice = self.calculateGestionPrices(tillAmount);
                _order.prices.promotions = self.calculatePromotionsAmount();

                // TRANSFERT_COMP objet redondant avec les sous totaux existant, sauf pour la clé services
                _order.prices.NAP = {
                    till: till,
                    printer: {
                        purchase: _isRental() ? 0 : printer.purchase.default,
                        rental: _isRental() ? printer.rental.default : 0
                    },
                    scanup: scanup.devices,
                    scanupOptions: scanup.options,
                    scanupSoftwares: scanup.softwares,
                    tabletAndPC: tabletAndPC,
                    tpe: tpe,
                    services: self.calculateDefaulNAPServicesPrices(),
                    tillAccessories: tillAccessoriesPrice,
                    cashDrawers: {
                        purchase: _isRental() ? 0 : cashDrawersPrice,
                        rental: _isRental() ? cashDrawersPrice : 0
                    }, gestion: self.calculateGestionPrices()
                };

                if (_isRental()) {
                    _order.prices.printerRental = printer[contractTypeNAP].default;
                    _order.prices.printerPurchase = 0;
                } else {
                    _order.prices.printerPurchase = printer[contractTypeNAP].default;
                    _order.prices.printerRental = 0;
                }

                _order.prices.tillSoftware = self.calculateSoftwarePricesNAP(tillAmount);
                _order.prices.scanup = scanup.devices[contractTypeNAP];
                _order.prices.scanupOptions = scanup.options[contractTypeNAP];
                _order.prices.scanupSoftwares = scanup.softwares[contractTypeNAP];
                _order.prices.tabletAndPC = tabletAndPC[contractTypeNAP];
                _order.prices.tpe = tpe.rental;
                _order.prices.servicesNAP = _order.prices.NAP.services;
                _order.prices.tillAccessories = tillAccessoriesPrice[contractTypeNAP];
                _order.prices.cashDrawers = cashDrawersPrice;
                _order.prices.gestion = self.calculateGestionPrices();

                // TRAD prices
            } else {
                // intermediate till related values used to calculate prices
                var tillOptionsList = [
                    'LOGICIEL_CAISSE',
                    'ACCESSOIRE_CAISSE',
                    'SAV',
                    'MAINTENANCE',
                    'EXTENSION',
                    'GESTION',
                    'GESTION_SCANUP',
                    'PACK_BOULANGERIE',
                    'SERVICE_LOGICIEL'
                ];
                var tillOptionsPrices = self.calculateTillOptionsPrices(tillAmount, tillOptionsList);

                _order.prices.till = self.calculateTillPricesTRAD();
                _order.prices.cashDrawers = self.calculateCashDrawersPrices();
                _order.prices.promotions = self.calculatePromotionsAmount();
                _order.prices.tillAccessories = tillOptionsPrices.accessoire_caisse;
                maintenancePrice = tillOptionsPrices.maintenance;
                savPrice = tillOptionsPrices.sav;
                extensionPrice = tillOptionsPrices.extension;
                _order.prices.gestion = tillOptionsPrices.gestion + tillOptionsPrices.gestion_scanup;
                _order.prices.tillSoftware = tillOptionsPrices.logiciel_caisse;
                // TRANSFERT_COMP Sous total pack boulangeries, uniquement présent sur l'offre 2017 TRAD
                _order.prices.packBoulangerie = self.applyDegressiveRate(
                    tillOptionsPrices.pack_boulangerie,
                    self.getDegressiveRate(_order, tillAmount)
                );
                _order.prices.softwareServices = tillOptionsPrices.service_logiciel;
                var scanupPrices = self.calculateScanupPrices(_order.contract.contractType.code);
                _order.prices.scanup = scanupPrices.devices;
                _order.prices.scanupOptions = scanupPrices.options;
                _order.prices.scanupSoftwares = scanupPrices.softwares;
                _order.prices.scanupBimediaPayOptions = scanupPrices.bimediaPayOptions;
                _order.prices.scanupBimediaPayDiscount = self.calculateBimediaPayDiscount();
                _order.prices.flashup = self.calculateFlashupPrices();
                _order.prices.tabletAndPC = self.calculateDefaultOptionsPricesTRAD();
                _order.prices.tpe = self.calculateTPEPrices();
                BBooster = self.calculateBBoosterPrices();
                _order.prices.activateBBoosterOptions = BBooster.purchase;
                _order.prices.BBoosterOptions = BBooster.rental;
                let prestations = self.calculatePrestationsPrices(_order.contract.contractType.code);
                _order.prices.prestationInstallation = prestations.install;
                _order.prices.prestationCateringSupport = prestations.cateringSupport;

                printer = self.calculatePrinterPricesTRAD();
                if (_isRental()) {
                    _order.prices.printerRental = printer.default;
                    _order.prices.printerPurchase = printer.supp;
                } else {
                    _order.prices.printerPurchase = printer.supp + printer.default;
                }

                // Generosity calculations
                if (_order.goodwillGestures) {
                    _order.goodwillGestures.amount.tpe = goodwillGesturesService.calculateGenerosity(
                        'TPE',
                        self.getContractTypeValue(),
                        _order
                    );
                    _order.goodwillGestures.amount.mds = self.calculateOfferedMaintenance();
                    _order.goodwillGestures.amount.revenue = self.calculateRevenue();
                    _order.goodwillGestures.amount.moneyTransferServices = self.calculateMoneyTransferServices(
                        tillAmount
                    );
                    _order.goodwillGestures.amount.exceptionalOffer = self.calculateExceptionalOffer();
                    _order.goodwillGestures.amount.fullPremiumOffer = self.calculateFullPremiumOffer()
                    _order.goodwillGestures.amount.bgreenOffer = self.calculateBgreenOffer();
                    _order.goodwillGestures.amount.quickInstall = self.calculateQuickInstallOffer()
                }
            }
            _order.prices.exceptionalOffer = _order.goodwillGestures && _order.goodwillGestures.amount.exceptionalOffer ? _order.goodwillGestures.amount.exceptionalOffer : 0;
            _order.prices.fullPremiumOffer = _order.goodwillGestures && _order.goodwillGestures.amount.fullPremiumOffer ? _order.goodwillGestures.amount.fullPremiumOffer : 0;
            _order.prices.bgreenOffer = _order.goodwillGestures && _order.goodwillGestures.amount.bgreenOffer ? _order.goodwillGestures.amount.bgreenOffer : 0;
            _order.prices.quickInstallOffer = _order.goodwillGestures && _order.goodwillGestures.amount.quickInstall ? _order.goodwillGestures.amount.quickInstall : 0;
            _order.prices.clubBimediaOffer = _order.goodwillGestures && _order.goodwillGestures.amount.clubBimedia && !_order.isClubBimediaOffer ? _order.goodwillGestures.amount.clubBimedia : 0;
            let prestation = self.calculatePrestationsPrices(_order.contract.contractType.code);
            _order.prices.prestationInstallation = prestation.install;
            _order.prices.maintenanceTill =
                tillPackService.is2017TillPack(_order.tills, _order.orderType.code) ||
                (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET()))
                    ? maintenancePrice
                    : self.calculateMaintenancePrices();
            _order.prices.sav = savPrice;
            _order.prices.warrantyExtension = extensionPrice;
            _order.prices.reintegration = self.calculateReintegrationPrices();
            _order.prices.tpeOptions = self.calculateTPEOptionsPrices().purchase;
            _order.prices.insurance = self.calculateInsurancePrices();


            // webTill
            _order.prices.packageInstallation = self.calculatePackagePrice('formationPrice');
            _order.prices.packageSubscription = self.calculatePackagePrice('subscriptionPrice');

            // option multi-device
            _order.prices.optionFleuristeCaisseWeb = self.calculateOptionFleuristeCaisseWebPrice();

            // Rental subtotal prices
            _order.prices.leaserSubtotal = self.calculateLeaserSubtotal();
            _order.prices.buralogSubtotal = self.calculateBuralogSubtotal();

            // Purchase Option subtotal prices
            _order.prices.purchaseOptionSubtotal = self.calculatePurchaseOptionSubtotal();

            // Proforma calculation after all prices have been updated subtotal prices are stored in _order.prices.proformaDetails
            _order.prices.proforma = self.calculateProformaTotalPrice();

            _order.prices.total = self.updateTotal();

            // Deloitte calculation price
            _order.prices.deloitteTotal = _order.contract.contractType.code !== null ? self.calculateDeloitte() : 0;
            _order.prices.deloitteMonthly = _order.prices.deloitteTotal / self.getContractTypeValue();

            let rate = {
                'LOC36': TRAD_LEASER_LOC36,
                'LOC48': TRAD_LEASER_LOC48,
                'LOC60': TRAD_LEASER_LOC60,
                'ACHAT': 1
            };

            _order.prices.ca = (_order.prices.leaserSubtotal - _order.prices.reintegration) / rate[_order.contract.contractType.code]
        };

        /**
         * Calculate the total rental and purchase
         * @return {Object} {
         *  purchase,
         *  rental
         * }
         */
        self.updateTotal = function updateTotal() {
            var total = {
                purchase: 0,
                rental: 0
            };

            // prices that follow till contract
            if (_isRental()) {
                total.rental += _order.prices.till;
                total.rental += _order.prices.tillSoftware;
                total.rental += _order.prices.tillAccessories;
                total.rental += _order.prices.reintegration;
                total.rental += _order.prices.printerRental;
                total.rental += _order.prices.tabletAndPC;
                total.rental += _order.prices.cashDrawers;
                total.rental += _order.prices.warrantyExtension;
                total.rental -= self.calculatePromotionsTotalAmount(_order.prices.promotions);
                total.rental -= _order.prices.exceptionalOffer;
                total.rental -= _order.prices.fullPremiumOffer;
                total.rental -= _order.prices.bgreenOffer;
                total.rental -= _order.prices.quickInstallOffer;
                total.rental -= _order.goodwillGestures && !_order.goodwillGestures.generosity.renunciationClubBimedia ? 0 : _order.prices.clubBimediaOffer;
            } else {
                total.purchase += _order.prices.till;
                total.purchase += _order.prices.tillSoftware;
                total.purchase += _order.prices.tillAccessories;
                total.purchase += _order.prices.tabletAndPC;
                total.purchase += _order.prices.cashDrawers;
                total.purchase += _order.prices.warrantyExtension;
                total.purchase -= _order.prices.exceptionalOffer;
                total.purchase -= _order.prices.fullPremiumOffer;
                total.purchase -= _order.prices.quickInstallOffer;
                total.purchase -= _order.goodwillGestures && !_order.goodwillGestures.generosity.renunciationClubBimedia ? 0 : _order.prices.clubBimediaOffer;
                if (!_isNAP()) {
                    total.purchase -= self.calculatePromotionsTotalAmount(_order.prices.promotions);

                }
            }
            // prices linked to other contracts
            if (_isScanupRental) {
                total.rental += _order.prices.scanup;
                total.rental += _order.prices.scanupOptions;
                if (_order.goodwillGestures && _order.goodwillGestures.amount.launchBimediaPay && !_isNAP()) {
                    // goodwillGesturesService.calculateLaunchBimediaPayTotal(_order);
                    total.rental -= _order.prices.scanupBimediaPayDiscount;
                }
            } else {
                total.purchase += _order.prices.scanup;
                total.purchase += _order.prices.scanupOptions;
                if (_order.goodwillGestures && _order.goodwillGestures.amount.launchBimediaPay && !_isNAP()) {
                    // goodwillGesturesService.calculateLaunchBimediaPayTotal(_order);
                    total.purchase -= _order.prices.scanupBimediaPayDiscount;
                }
            }

            if (_isFlashupRental) {
                total.rental += _order.prices.flashup;
            } else {
                total.purchase += _order.prices.flashup;
            }

            if (_isInstallRental) {
                total.rental += _order.prices.prestationInstallation;
            } else {
                total.purchase += _order.prices.prestationInstallation;
            }

            if (!_isNAP()) {
                if (_isCateringSupportRental) {
                    total.rental += _order.prices.prestationCateringSupport;
                } else {
                    total.purchase += _order.prices.prestationCateringSupport;
                }
            }


            // Purchase only prices
            total.purchase += _order.prices.printerPurchase;
            total.purchase += _order.prices.tpeOptions;
            total.purchase += _order.prices.packageInstallation;
            if (!_isNAP()) {
                total.purchase += _order.prices.activateBBoosterOptions;
            }

            // Rental only prices
            total.rental += _order.prices.tpe;
            total.rental += _order.prices.maintenanceTill + _order.prices.sav;
            total.rental += _order.prices.gestion;
            total.rental += _order.prices.softwareServices;
            total.rental += _order.prices.packBoulangerie;
            total.rental += _order.prices.insurance;
            total.rental += _order.prices.packageSubscription;
            total.rental += _order.prices.optionFleuristeCaisseWeb;
            if (!_isNAP()) {
                total.rental += _order.prices.BBoosterOptions;
                total.rental += _order.prices.scanupBimediaPayOptions;
            }

            if (_order.goodwillGestures) {
                _order.goodwillGestures.amount.total = 0;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.mds;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.tpe;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.tillPartExchange;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.revenue;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.welcomeBonus;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.scanupPartExchange;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.cashinServices;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.servicesFestival;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.moneyTransfer.clubBimedia === false ? _order.goodwillGestures.amount.moneyTransferServices : 0;
                _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.scanupServices;

                if (!_isNAP()) {
                    _order.goodwillGestures.amount.total += _order.contract.contractType.code !== 'ACHAT' ? _order.goodwillGestures.amount.eagle : _order.goodwillGestures.amount.eagle / 48;
                    _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.launchBimediaPay;
                    _order.goodwillGestures.amount.total += _order.goodwillGestures.amount.launchBBooster;
                    if (_order.goodwillGestures.amount.launchBBooster) {
                        total.rental -=
                            _order.prices.BBoosterOptions - goodwillGesturesService.LAUNCH_B_BOOSTER_MONTHLY_AMOUNT;
                        total.purchase -= _order.prices.activateBBoosterOptions;
                    }

                }
            }

            if (_isNAP()) {
                total.purchase += _order.prices.servicesNAP;
            }

            return total;
        };

        self.calculateLeaserSubtotal = function calculateLeaserSubtotal() {
            var subtotal = 0;

            subtotal += _order.prices.till + _order.prices.cashDrawers;
            subtotal += _order.prices.tillSoftware + _order.prices.tillAccessories;
            subtotal += _order.prices.tabletAndPC + _order.prices.reintegration;
            subtotal += _order.prices.warrantyExtension;
            if (!_isNAP()) {
                subtotal -= self.calculatePromotionsTotalAmount(_order.prices.promotions);
                subtotal -= _order.prices.exceptionalOffer ;
                subtotal -= _order.prices.fullPremiumOffer;
                subtotal -= _order.prices.bgreenOffer;
                subtotal -= _order.prices.quickInstallOffer;
                subtotal -= _order.prices.clubBimediaOffer;
            }

            subtotal += _isRental() === true ? _order.prices.printerRental : _order.prices.printerPurchase;

            // Options based on scanup contract
            if (
                _isRental() === false ||
                (typeof _order.scanupContractType != 'undefined' && _order.scanupContractType.code !== 'ACHAT')
            ) {
                subtotal += _order.prices.scanup + _order.prices.scanupOptions;
                if (_order.goodwillGestures && _order.goodwillGestures.amount.launchBimediaPay && !_isNAP()) {
                    subtotal -= _order.prices.scanupBimediaPayDiscount;
                }
            }

            if (!_isRental() || typeof _order.installContractType !== 'undefined' && _order.installContractType.code !== 'ACHAT') {
                subtotal += _order.prices.prestationInstallation;
            }
            if ((!_isRental() || (typeof _order.cateringSupportContractType !== 'undefined' && _order.cateringSupportContractType.code !== 'ACHAT')) && !_isNAP()) {
                subtotal += _order.prices.prestationCateringSupport;
            }

            return subtotal;
        };

        self.calculateBuralogSubtotal = function calculateBuralogSubtotal() {
            var subtotal = 0;

            subtotal += _order.prices.maintenanceTill + _order.prices.sav;
            subtotal += _order.prices.gestion;
            subtotal += _order.prices.tpe;
            subtotal += _order.prices.insurance;
            if (!_isNAP()) {
                subtotal += _order.prices.scanupBimediaPayOptions;
                subtotal += !(_order.goodwillGestures && _order.goodwillGestures.amount.launchBBooster)
                    ? _order.prices.BBoosterOptions
                    : _order.prices.BBoosterOptions - goodwillGesturesService.LAUNCH_B_BOOSTER_MONTHLY_AMOUNT;
            }

            return subtotal;
        };

        self.calculatePurchaseOptionSubtotal = function calculatePurchaseOptionSubtotal() {
            var subtotal = 0;

            subtotal += _order.prices.tpeOptions;
            subtotal +=
                _order.goodwillGestures && _order.goodwillGestures.amount.launchBBooster && !_isNAP()
                    ? 0
                    : _order.prices.activateBBoosterOptions;
            if (!_isScanupRental && _order.contract.contractType.code !== 'ACHAT') {
                subtotal += _order.prices.scanup;
                subtotal += _order.prices.scanupOptions;
                if (_order.goodwillGestures && _order.goodwillGestures.amount.launchBimediaPay && !_isNAP()) {
                    subtotal -= _order.prices.scanupBimediaPayDiscount;
                }
            }
            if (!_isInstallRental && _order.contract.contractType.code !== 'ACHAT') {
                subtotal += _order.prices.prestationInstallation;
            }
            if (!_isCateringSupportRental && _order.contract.contractType.code !== 'ACHAT' && !_isNAP()) {
                subtotal += _order.prices.prestationCateringSupport;
            }

            return subtotal;
        };

        /* =========================================================================================== */
        /*                                    Packages                                                 */
        /* =========================================================================================== */

        /**
         * @param {String} type
         * @param {boolean} tva
         * @returns {number}
         */
        self.calculatePackagePrice = function calculatePackagePrice(type, tva) {
            type = type === undefined ? '' : type;
            tva = tva === undefined ? false : tva;
            var price = 0;
            var finalPrice = 0;
            var priceObject = null;

            // Get the correct price object
            if (typeof _order.package.prices !== 'undefined') {
                priceObject = _order.package.prices[0];
            } else if (typeof _order.package.price !== 'undefined') {
                priceObject = _order.package.price;
            }

            if (priceObject) {
                // Get the price depending on the type parameter (formation or subscription)
                if (type === 'formationPrice') {
                    price = priceObject.formationPrice;
                } else if (type === 'subscriptionPrice') {
                    price = priceObject.subscriptionPrice;
                }
                // Calculate the full price (with the TVA) if needed
                if (tva) {
                    // tva is stored in the database this way : 0.2 for 20%
                    var tvaAmount = priceObject.tva * price;
                    finalPrice = price + tvaAmount;
                } else {
                    finalPrice = price;
                }
            }
            return finalPrice;
        };

        /* =========================================================================================== */
        /*                           Option fleuriste caisse web                                       */
        /* =========================================================================================== */

        self.calculateOptionFleuristeCaisseWebPrice = function calculateOptionFleuristeCaisseWebPrice() {
            for (var j = 0; j < _order.options.length; j++) {
                if (_order.options[j].code === 'MULTI-DEVICE') {
                    for (var k = 0; k < _order.options[j].prices.length; k++) {
                        if (_order.contract.contractType.code === _order.options[j].prices[k].type.code) {
                            return _order.options[j].prices[k].value;
                        }
                    }
                }
            }
            return 0;
        };

        /* =========================================================================================== */
        /*                                         TILLS                                               */
        /* =========================================================================================== */

        /**
         * Get the correct price for the till type and nb tills
         * @param {String} tillTypeCode
         * @param {int} nbTills
         * @param {String} contractTypeCode
         * @param {boolean} returnPromotionValue
         * @return {Number}
         */
        self.getSimpleTillPrice = function getSimpleTillPrice(
            tillTypeCode,
            nbTills,
            contractTypeCode,
            returnPromotionValue
        ) {
            returnPromotionValue = returnPromotionValue === undefined ? false : returnPromotionValue;
            var prices = [];
            // Without extension price parameter check (for TRAD orderType)
            if (
                tillPackService.is2017TillPack(_order.tills, _order.orderType.code) ||
                (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET()))
            ) {
                for (var i = 0; i < _orderForm.tillPrices.length; i++) {
                    if (
                        _orderForm.tillPrices[i].tillType.code === tillTypeCode &&
                        _orderForm.tillPrices[i].combinedRule === null &&
                        _orderForm.tillPrices[i].orderType.code === _order.orderType.code &&
                        _orderForm.tillPrices[i].nbTills === nbTills
                    ) {
                        prices = _orderForm.tillPrices[i].prices;
                        break;
                    }
                }
                // With extension price paramenter check
            } else {
                var isTillExtensionPrice = _isNAP() ? napService.isTillExtensionPrice(_order) : _isExtensionScenario();
                for (var i = 0; i < _orderForm.tillPrices.length; i++) {
                    if (
                        _orderForm.tillPrices[i].tillType.code === tillTypeCode &&
                        _orderForm.tillPrices[i].combinedRule === null &&
                        _orderForm.tillPrices[i].orderType.code === _order.orderType.code &&
                        _orderForm.tillPrices[i].nbTills === nbTills &&
                        _orderForm.tillPrices[i].isExtensionScenario === isTillExtensionPrice
                    ) {
                        prices = _orderForm.tillPrices[i].prices;
                        break;
                    }
                }
            }
            for (var k = 0; k < prices.length; k++) {
                if (prices[k].type.code === contractTypeCode && prices[k].marketType.code === _order.marketType.code) {
                    if (returnPromotionValue) {
                        return prices[k].promotionValue;
                    } else {
                        return prices[k].value;
                    }
                }
            }

            return 0;
        };

        /**
         * Calcule le montant des promotions activée pour chaque type de promotion
         * @returns object {}
         */
        self.calculatePromotionsAmount = function calculatePromotionsAmount() {
            const potentialAmountByPromotion = self.calculatePotentialPromotionsAmount();

            var promotionsAmount = [];
            for (const promotion of _order.promotions) {
                if (potentialAmountByPromotion.hasOwnProperty(promotion.code)) {
                    promotionsAmount[promotion.code] = potentialAmountByPromotion[promotion.code];
                }
            }

            return promotionsAmount;
        };

        /**
         * Calcule la valeur potentielle de la promotion pour chaque type de promotion
         * @returns object {{B_MOOV: *, B_TOUCH: *}}
         */
        self.calculatePotentialPromotionsAmount = function calculatePotentialPromotionsAmount() {
            const nbTillsByType = orderService.getNbTillsByTillType(_order.tills);
            const totalNbTills = orderService.getNbTills(_order.tills);

            const promotions = {
                ESSENTIEL: self.getSimpleTillPrice('ESSENTIEL', totalNbTills, _order.contract.contractType.code, true),
                PREMIUM: self.getSimpleTillPrice('PREMIUM', totalNbTills, _order.contract.contractType.code, true),
                BM: self.getSimpleTillPrice('BM', totalNbTills, _order.contract.contractType.code, true),
                'BT+': self.getSimpleTillPrice('BT+', totalNbTills, _order.contract.contractType.code, true),
                'BM+': self.getSimpleTillPrice('BM+', totalNbTills, _order.contract.contractType.code, true),
                BS_PREMIUM : self.getSimpleTillPrice('BS_PREMIUM', totalNbTills, _order.contract.contractType.code, true),
                BSW_PREMIUM : self.getSimpleTillPrice('BSW_PREMIUM', totalNbTills, _order.contract.contractType.code, true),
                BSW_ESSENTIEL : self.getSimpleTillPrice('BSW_ESSENTIEL', totalNbTills, _order.contract.contractType.code, true),
                BC_ESSENTIEL : self.getSimpleTillPrice('BC_ESSENTIEL', totalNbTills, _order.contract.contractType.code, true),
            };
            let modules = _order.options.filter(option => option.code === 'LOGICIEL_CAISSE_TABAC' || option.code === 'LOGICIEL_CAISSE_PRESSE');
            if (modules.length === 2 ) {
                promotions.BSW_PREMIUM = self.priceConverter(17);
                promotions.BSW_ESSENTIEL = self.priceConverter(14);
            }
            let softwares = _order.options.filter(option => option.optionType.code === 'LOGICIEL_CAISSE');
            let moduleFdj = _order.options.filter(option => option.code === 'FDJ_SERVICES_DIGITAUX');
            if(moduleFdj.length === 1 && softwares.length === 2 && moment(_order.dateCreated).isBefore('2026-01-21') ) {
                promotions.BC_ESSENTIEL = self.priceConverter(6);
                promotions.BSW_PREMIUM = self.priceConverter(17);
                promotions.BSW_ESSENTIEL = self.priceConverter(14);
            }
            var nbTillsCurrentCode = 0;
            for (const tillCode in promotions) {
                nbTillsCurrentCode = nbTillsByType.hasOwnProperty(tillCode) ? nbTillsByType[tillCode] : 0;
                promotions[tillCode] =
                    nbTillsCurrentCode > 0 ? Math.floor((promotions[tillCode] / totalNbTills) * nbTillsCurrentCode) : 0;
            }

            return promotionService.groupValuesByPromotionCode(promotions);
        };

        /**
         * Retourne la valeur totale des promotions sur les caisses
         * @param {Object} promotionValues la liste des valeurs pour chaque type promotion
         * @returns {Number}
         */
        self.calculatePromotionsTotalAmount = function calculatePromotionsTotalAmount(promotionValues) {
            return Object.values(promotionValues).reduce(function (total, currentValue) {
                return total + currentValue;
            }, 0);
        };

        /**
         * Calculate the till prices for a non mixed configuration
         * @param {String} tillType
         * @param {String} contractTypeCode
         * @return {Object}
         */
        function _calculateSimpleTillPrices(tillType, contractTypeCode) {
            var nbTotalTills = 0;
            // Remember : with extension scenario we only can add one till
            // However the price depends on the number of tills previously purchased by the client
            if (
                _isExtensionScenario() &&
                !tillPackService.is2017TillPack(_order.tills, _order.orderType.code) &&
                offerService.isOlderOffer(_order) === true
            ) {
                nbTotalTills = _order.contract.nbTillsAdded;
            } else {
                for (var i = 0; i < _order.tills.length; i++) {
                    nbTotalTills += _order.tills[i].nbTills;
                }
            }

            return self.getSimpleTillPrice(tillType, nbTotalTills, contractTypeCode);
        }

        /**
         * Get a till rule identified by its id
         * @param  {int} tillRuleId
         * @return {Object}
         */
        function _getTillRule(tillRuleId) {
            for (var i = 0; i < _orderForm.tillPrices.length; i++) {
                if (_orderForm.tillPrices[i].id === tillRuleId) {
                    return _orderForm.tillPrices[i];
                }
            }
        }

        /**
         * Get the mixed till pack price
         * A combined rule is determined by the association of different tillTypes
         * @param {Object} nbTills
         * @param {String} contractTypeCode
         * @return {Object} Total tills price for each tillType: {tillType: total price, ...}
         */
        self.getMixedTillPrice = function getMixedTillPrice(nbTills, contractTypeCode) {
            var combinedRule;
            var price = {},
                prices = {};
            return computeMixedPricesWithTheNewRule(nbTills);
            // if (tillPackService.hasBmoovPack(_order.tills) || tillPackService.hasBmoovPlusPack(_order.tills) || tillPackService.hasBsmartPack(_order.tills)
            //     || tillPackService.hasBgreenPack(_order.tills) || tillPackService.hasMaintenancePackage(_order.tills)
            //     || tillPackService.hasBtouchRefurbishedPack(_order.tills) || tillPackService.hasBswiftPack(_order.tills)
            //     || tillPackService.hasBwidePack(_order.tills)) {
            //     return computeMixedPricesWithTheNewRule(nbTills);
            // }
            //
            // // Init objects prices to [] and price to 0 for each tillType found in the orderForm
            // _orderForm.tills.forEach(function (till) {
            //     if (prices[till.tillType.code] === undefined) {
            //         prices[till.tillType.code] = [];
            //     }
            //     if (price[till.tillType.code] === undefined) {
            //         price[till.tillType.code] = 0;
            //     }
            // });
            //
            // for (var i = 0; i < _orderForm.tillPrices.length; i++) {
            //     if (
            //         _orderForm.tillPrices[i].combinedRule !== null &&
            //         _orderForm.tillPrices[i].nbTills === nbTills[_orderForm.tillPrices[i].tillType.code] &&
            //         _orderForm.tillPrices[i].orderType.code === _order.orderType.code
            //     ) {
            //         combinedRule = _getTillRule(_orderForm.tillPrices[i].combinedRule);
            //         if (combinedRule.nbTills === nbTills[combinedRule.tillType.code]) {
            //             prices[_orderForm.tillPrices[i].tillType.code] = prices[
            //                 _orderForm.tillPrices[i].tillType.code
            //                 ].concat(_orderForm.tillPrices[i].prices);
            //             prices[combinedRule.tillType.code] = prices[combinedRule.tillType.code].concat(
            //                 combinedRule.prices
            //             );
            //             break;
            //         }
            //     }
            // }
            //
            // // Sum prices array into price total for each tillType
            // Object.keys(prices).forEach(function (tillTypeCode) {
            //     if (prices[tillTypeCode].length > 0) {
            //         var priceToSum = prices[tillTypeCode].find(function (currentPrice) {
            //             return currentPrice.type.code === contractTypeCode;
            //         });
            //         price[tillTypeCode] += priceToSum.value;
            //     }
            // });
            //
            // return price;
        };

        /**
         * Get the mixed till pack price for NAP network
         * A combined rule is determined by the association of different tillTypes
         * @param {Object} nbTills
         * @param {String} contractTypeCode
         * @return {Object} Total tills price for each tillType: {tillType: total price, ...}
         */
        self.getMixedTillPriceNAP = function getMixedTillPriceNAP(nbTillsByTillTypes, contractTypeCode) {
            let price = {};

            for (const tillTypeCode in nbTillsByTillTypes) {
                const nbTillsCurrent = nbTillsByTillTypes[tillTypeCode];
                price[tillTypeCode] = self.getSimpleTillPrice(tillTypeCode, nbTillsCurrent, contractTypeCode, false);
            }

            return price;
        };

        function computeMixedPricesWithTheNewRule(nbTillsByTillTypes) {
            const totalNbTills = orderService.getNbTillsWithoutMaintenancePackage(_order.tills);

            let tillTypes = [];
            Object.keys(nbTillsByTillTypes).forEach(tillType => {
                if (['FORFAIT', 'PREMIUM_RECONDITIONNE'].indexOf(tillType) === -1 && nbTillsByTillTypes[tillType] !== 0)
                    tillTypes.push(tillType);
            })
            let prices = {};
            if (tillPackService.hasMaintenancePackage(_order.tills) || tillPackService.hasBtouchRefurbishedPack(_order.tills) && tillTypes.length === 1) {
                _order.tills.forEach(function (till) {
                    prices[till.tillType.code] = self.getSimpleTillPrice(
                        till.tillType.code,
                        nbTillsByTillTypes[till.tillType.code],
                        _order.contract.contractType.code,
                        false
                    );
                });
                return prices;
            }

            _order.tills.forEach(function (till) {
                if (['FORFAIT', 'PREMIUM_RECONDITIONNE'].indexOf(till.tillType.code) > -1) {
                    prices[till.tillType.code] = self.getSimpleTillPrice(
                        till.tillType.code,
                        nbTillsByTillTypes[till.tillType.code],
                        _order.contract.contractType.code,
                        false
                    );
                } else {
                    prices[till.tillType.code] = self.getSimpleTillPrice(
                        till.tillType.code,
                        1,
                        _order.contract.contractType.code,
                        false
                    );
                }

            });
            // reduction rule for multiple tills
            const reduction = totalNbTills > 1 ? 1 - ((totalNbTills - 2) * 0.05 + 0.15) : 0;
            for (const key in prices) {
                if (prices.hasOwnProperty(key) && ['FORFAIT', 'PREMIUM_RECONDITIONNE'].indexOf(key) === -1) {
                    let price = prices[key];
                    price *= reduction;
                    price = Math.round(price);
                    price *= nbTillsByTillTypes[key];
                    prices[key] = Math.round(price);
                }
            }
            return prices;
        }

        /**
         * calculate mixed till prices
         * @param {String} contractType
         * @return {Number}
         */
        function _calculateMixedTillPrices(contractTypeCode) {
            var prices;
            if (_isNAP()) {
                prices = self.getMixedTillPriceNAP(orderService.getNbTillsByTillType(_order.tills), contractTypeCode);
            } else {
                prices = self.getMixedTillPrice(orderService.getNbTillsByTillType(_order.tills), contractTypeCode);
            }

            // Get all prices in an array and sum all array elements
            return Object.keys(prices)
                .map(function (key) {
                    return prices[key];
                })
                .reduce(function (acc, price) {
                    return acc + price;
                }, 0);
        }

        /**
         * Calculate till prices with a given contract type and degressive rate to apply
         * Allows for normal degressive rate or custom rate
         * Uses till price for amount of 1 to apply rate before multypling by the amount
         * @param       {String} contractTypeCode
         * @param       {Number} degressiveRate
         * @return      {Number}  total price for the till pack
         */
        function _calculateDegressiveRateTillPrices(contractTypeCode, degressiveRate) {
            var prices = self.getDegressiveRateTillPrices(contractTypeCode, degressiveRate);
            return self.sumPrices(Object.values(prices));
        }

        /**
         * Get till prices with a given contract type and degressive rate to apply
         * @param {String} contractTypeCode
         * @param {Number} degressiveRate
         * @return {Object} Total tills price for each tillType: {tillType: total price, ...}
         */
        self.getDegressiveRateTillPrices = function getDegressiveRateTillPrices(contractTypeCode, degressiveRate) {
            let prices = {};
            let nbTillsObject = orderService.getNbTillsByTillType(_order.tills);

            _orderForm.tills.forEach(function (till) {
                if (prices[till.tillType.code] === undefined) {
                    prices[till.tillType.code] = 0;
                }
            });

            Object.keys(nbTillsObject).forEach(function (tillType) {
                if (tillType === 'FORFAIT')
                    degressiveRate = 0;
                prices[tillType] =
                    self.applyDegressiveRate(self.getSimpleTillPrice(tillType, 1, contractTypeCode), degressiveRate) *
                    nbTillsObject[tillType];
            });

            return prices;
        };

        /**
         * Get module software price for order with 'materialTill' offer
         * @returns {number}
         * @private
         */
        function _getMaterialTillFloristSoftwareModulePrice(optionLabel) {
            var nbTills = orderService.getNbTills(_order.tills);
            var listPrices = _orderForm.priceList;
            var result = 0;
            if (nbTills > 0 && optionLabel === 'FLEURISTE' && _order.offer.code === 'materialTill') {
                listPrices.forEach(function (price) {
                    if (price.tillNumber === nbTills && price.contractType.code === _order.contract.contractType.code) {
                        result = price.price;
                    }
                });
            }

            return parseInt(result);
        }

        /**
         * Get the tills prices for TRAD
         * @return {Number}
         */
        self.calculateTillPricesTRAD = function calculateTillPricesTRAD(contractTypeCode) {
            var mixedTillTypes = orderService.areTillsMixed(_order.tills);
            contractTypeCode = contractTypeCode || _order.contract.contractType.code;

            var nbTills = orderService.getNbTills(_order.tills);
            let nbTillsWithoutMaintenancePackage = orderService.getNbTillsWithoutMaintenancePackage(_order.tills);
            // custom rate allowed for tills
            var degressiveRate = self.getDegressiveRate(_order, nbTillsWithoutMaintenancePackage, true);

            // condition for 2017 offer
            if (tillPackService.is2017TillPack(_order.tills, _order.orderType.code)) {
                return self.applyDegressiveRate(
                    _calculateSimpleTillPrices(mixedTillTypes.tillType, contractTypeCode),
                    degressiveRate
                );
            }
            // 2018 offer with custom rate
            if (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET()) && _order.isMultiStores) {
                return _calculateDegressiveRateTillPrices(contractTypeCode, degressiveRate);
            }

            if (mixedTillTypes.isMixed) {
                return _calculateMixedTillPrices(contractTypeCode);
            }

            return _calculateSimpleTillPrices(mixedTillTypes.tillType, contractTypeCode);
        };

        /**
         * Get the tills prices for TRAD
         * @return {Number}
         */
        let _calculateTillPricesTRAD = function (order) {
            const mixedTillTypes = orderService.areTillsMixed(order.tills);
            const contractTypeCode = order.contract.contractType.code;

            const nbTillsWithoutMaintenancePackage = orderService.getNbTillsWithoutMaintenancePackage(order.tills);
            // custom rate allowed for tills
            const degressiveRate = self.getDegressiveRate(order, nbTillsWithoutMaintenancePackage, true);

            // condition for 2017 offer
            if (tillPackService.is2017TillPack(order.tills, order.orderType.code)) {
                return self.applyDegressiveRate(
                    _calculateSimpleTillPrices(mixedTillTypes.tillType, contractTypeCode),
                    degressiveRate
                );
            }
            // 2018 offer with custom rate
            if (offerService.isOlderOffer(order) === false && (_isTRAD() || _isFLORAJET()) && order.isMultiStores) {
                return _calculateDegressiveRateTillPrices(contractTypeCode, degressiveRate);
            }

            if (mixedTillTypes.isMixed) {
                let prices = self.getMixedTillPrice(orderService.getNbTillsByTillType(order.tills), contractTypeCode);

                // Get all prices in an array and sum all array elements
                return Object.keys(prices)
                    .map(function (key) {
                        return prices[key];
                    })
                    .reduce(function (acc, price) {
                        return acc + price;
                    }, 0);
            }

            const nbTills = orderService.getNbTills(order.tills);
            return self.getSimpleTillPrice(mixedTillTypes.tillType, nbTills, contractTypeCode, false);
        };

        /**
         * get the tills prices for NAP according to the given contractTypeCode
         * @param  {String} contractTypeCode
         * @return {Object} {
         *   rental,
         *   purchase
         * }
         */
        self.calculateTillPricesNAP = function calculateTillPricesNAP(contractTypeCode) {
            var mixedTillTypes = orderService.areTillsMixed(_order.tills);

            if (mixedTillTypes.isMixed) {
                return {
                    purchase: _calculateMixedTillPrices('ACHAT'),
                    rental: _calculateMixedTillPrices(contractTypeCode)
                };
            }

            return {
                purchase: _calculateSimpleTillPrices(mixedTillTypes.tillType, 'ACHAT'),
                rental: _calculateSimpleTillPrices(mixedTillTypes.tillType, contractTypeCode)
            };
        };

        /* =========================================================================================== */
        /*                                   CASH DRAWERS                                              */
        /* =========================================================================================== */

        self.calculateCashDrawersPrices = function calculateCashDrawersPrices() {
            var totalPrice = 0;
            _order.cashDrawers.forEach(function (cashDrawer) {
                var priceToAdd = self.getUnitPrice(
                    cashDrawer.prices,
                    _order.contract.contractType.code,
                    _order.marketType.code
                ) || {value: 0};
                // Older offers and BT+ pack
                if (
                    tillPackService.is2017TillPack(_order.tills, _order.orderType.code) === false &&
                    offerService.isOlderOffer(_order) === true
                ) {
                    return 0;
                }

                if (purchaseOptionsRateCondition() === true) {
                    totalPrice += Math.round(priceToAdd.value * cashDrawer.nbCashDrawers * TAUX_OPTIONS_ACHAT);
                } else if (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET())) {
                    totalPrice +=
                        self.applyDegressiveRate(
                            priceToAdd.value,
                            self.getDegressiveRate(_order, cashDrawer.nbCashDrawers),
                            false,
                            !cashDrawer.refurbished
                        ) * cashDrawer.nbCashDrawers;
                } else {
                    totalPrice += priceToAdd.value * cashDrawer.nbCashDrawers;
                }
            });

            return totalPrice;
        };

        /**
         *
         * @param  {Object} cashdrawer
         * @return {Number}
         */
        self.getCashDrawerUnitPrice = function getCashDrawerUnitPrice(cashdrawer) {
            var basePrice = self.getUnitPrice(
                cashdrawer.prices,
                _order.contract.contractType.code,
                _order.marketType.code
            ) || {value: 0};
            var unitPrice = 0;

            if (purchaseOptionsRateCondition() === true) {
                unitPrice = Math.round(basePrice.value * TAUX_OPTIONS_ACHAT);
            } else if (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET())) {
                let round = !cashdrawer.refurbished;
                unitPrice = self.applyDegressiveRate(
                    basePrice.value,
                    self.getDegressiveRate(_order, cashdrawer.nbCashDrawers),
                    false,
                    !cashdrawer.refurbished
                );
            } else {
                unitPrice = basePrice.value;
            }
            return unitPrice;
        };


        /* =========================================================================================== */
        /*                                   GOODWILL GESTURES                                         */
        /* =========================================================================================== */

        /**
         * Calculate the maintenance offered
         * @return {Number}
         */
        self.calculateOfferedMaintenance = function calculateOfferedMaintenance() {
            if (!_order.goodwillGestures) {
                return 0;
            }

            // 2017 and 2018 offers
            if (
                tillPackService.is2017TillPack(_order.tills, _order.orderType.code) ||
                (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET()))
            ) {
                var tillAmount = orderService.getNbTills(_order.tills);
                var degressiveRate = self.getDegressiveRate(_order, tillAmount);

                var tillOptions = {
                    amount: tillAmount,
                    rate: degressiveRate,
                    rateFunction: self.applyDegressiveRate
                };
                return (
                    goodwillGesturesService.calculateGenerosity(
                        'MAINTENANCE',
                        self.getContractTypeValue(),
                        _order,
                        tillOptions
                    ) +
                    goodwillGesturesService.calculateGenerosity(
                        'SAV',
                        orderService.getSAVMonths(_order),
                        _order,
                        tillOptions
                    )
                );
            } else {
                return (
                    self.getMaintenancePrices() *
                    (_order.goodwillGestures.mds.nbMDSRDS + _order.goodwillGestures.mds.nbMDSDRV)
                );
            }
        };

        /**
         * Calculate revenue price
         * @return {Number}
         */
        self.calculateRevenue = function calculateRevenue() {
            if (!_order.goodwillGestures || _order.goodwillGestures.revenue === null ||
                ( _order.goodwillGestures.revenue && _order.goodwillGestures.revenue.typeCode && _order.goodwillGestures.revenue.typeCode.indexOf('GLADY') > -1)) {
                return 0;
            }

            return _order.goodwillGestures.revenue.rateValue * self.getContractTypeValue();
        };

        /**
         * Calculate the maximum amount of the offer MoneyTransferService
         * @param numberOfTills
         */
        self.calculateMoneyTransferServices = function calculateMoneyTransferServices(numberOfTills) {
            if (
                !_order.goodwillGestures ||
                _order.goodwillGestures.moneyTransfer.enabled === false ||
                _order.goodwillGestures.moneyTransfer.levelId === null
            ) {
                return 0;
            }

            let moneyTransferMonthlyRefundAmount = 0;
            let moneyTransferTotalRefundAmount = 0;

            moneyTransferMonthlyRefundAmount = self.calculateMoneyTransferMonthly(numberOfTills);

            moneyTransferMonthlyRefundAmount = goodwillGesturesService.applyCeilingToMonthlyPrice(
                moneyTransferMonthlyRefundAmount,
                _order
            );

            if (_order.contract.contractType.code === 'ACHAT') {
                moneyTransferTotalRefundAmount =
                    moneyTransferMonthlyRefundAmount * orderService.getContractMonths(_order);
            } else {
                moneyTransferTotalRefundAmount = moneyTransferMonthlyRefundAmount;
            }

            return moneyTransferTotalRefundAmount;
        };

        self.calculateMoneyTransferMonthly = function calculateMoneyTransferMonthly(numberOfTills) {
            let tillRefundAmount = 0;
            let scanupRefundAmount = 0;
            let totalRefundAmount = 0;

            self.isScanup = orderService.isScanupSelected(_order.options);

            if (self.isScanup === true && numberOfTills > 0) {
                tillRefundAmount = self.calculateMoneyTransferTillPrice(numberOfTills);
                scanupRefundAmount = self.calculateMoneyTransferScanupPrice();
            } else if (self.isScanup) {
                scanupRefundAmount = self.calculateMoneyTransferScanupPrice();
            } else if (numberOfTills > 0) {
                tillRefundAmount = self.calculateMoneyTransferTillPrice(numberOfTills);
            }

            if (tillRefundAmount > 0) {
                tillRefundAmount = goodwillGesturesService.applyRefundRateToTill(tillRefundAmount, _order);
            }
            if (scanupRefundAmount > 0) {
                scanupRefundAmount = goodwillGesturesService.applyRefundRateToScanup(scanupRefundAmount, _order);
            }

            totalRefundAmount = tillRefundAmount + scanupRefundAmount;

            if (_order.contract.contractType.code === 'ACHAT') {
                totalRefundAmount = totalRefundAmount / orderService.getContractMonths(_order);
            }

            return totalRefundAmount;
        };

        self.calculateMoneyTransferTillPrice = function calculateMoneyTransferTillPrice(numberOfTills) {
            let tillPrice = 0;
            const tillOptionsList = [
                'LOGICIEL_CAISSE',
                'ACCESSOIRE_CAISSE',
                'SAV',
                'EXTENSION',
                'PACK_BOULANGERIE',
                'SERVICE_LOGICIEL'
            ];

            const tillOptionsPrices = self.calculateTillOptionsPrices(numberOfTills, tillOptionsList);
            Object.keys(tillOptionsPrices).forEach(function (key) {
                tillPrice += tillOptionsPrices[key];
            });

            tillPrice += _order.prices.till;
            tillPrice += _order.prices.cashDrawers;

            return tillPrice;
        };

        self.calculateMoneyTransferScanupPrice = function calculateMoneyTransferScanupPrice() {
            let scanupPrice = 0;
            const scanupPricesObject = self.calculateScanupPrices();

            scanupPrice += scanupPricesObject.devices;
            scanupPrice += scanupPricesObject.moneyTransferOptions;

            return scanupPrice;
        };

        self.calculateExceptionalOffer = function (control) {
            control = typeof (control) === 'undefined' ? false : control;
            let price = 0;
            if (_order.isExceptionalOffer || control) {
                let pallier = 0;
                let order = JSON.parse(JSON.stringify(_order));
                if(tillPackService.hasBgreenPack(order.tills)){
                    order.tills = order.tills.reduce((curr, till) => {
                        if(till.tillType.code !== 'BG_ESSENTIEL' && till.tillType.code !== 'BG_PREMIUM')
                            curr.push(till);
                        return curr;
                    }, [])
                    order.prices.till = _calculateTillPricesTRAD(order);
                }
                if(tillPackService.hasBwidePack(order.tills)){
                    order.tills = order.tills.reduce((curr, till) => {
                        if(till.tillType.code !== 'BW_ESSENTIEL' && till.tillType.code !== 'BW_PREMIUM')
                            curr.push(till);
                        return curr;
                    }, [])
                    order.prices.till = _calculateTillPricesTRAD(order);
                }
                let nbTills = orderService.getNbTills(order.tills);
                let mixedTillTypes = orderService.areTillsMixed(order.tills);
                const contractType = order.contract.contractType.code;
                if (!mixedTillTypes.isMixed) {
                    let tillType = tillPackService.hasBsmartPack(order.tills) ? 'BS' : tillPackService.hasBtouchPack(order.tills) ? 'BT'
                        : tillPackService.hasBswiftPack(order.tills) ? 'BSW' : 'BM';
                    pallier = goodwillGesturesService.EXCEPTIONAL_OFFER[nbTills][contractType][tillType];
                }else{
                    let nbTillsByType = orderService.getNbTillsByTillType(order.tills);
                    let amountBG = 0;
                    let amountBT = 0;
                    let amountBS = 0;
                    let amountBM = 0;
                    let amountBW = 0;
                    let amountBSW = 0;
                    Object.keys(nbTillsByType).forEach(type => {
                        if (['BG_ESSENTIEL', 'BG_PREMIUM'].indexOf(type) !== -1 && nbTillsByType[type] !== 0){
                            amountBG += goodwillGesturesService.EXCEPTIONAL_OFFER[nbTillsByType[type]][contractType]['BG'];
                            nbTills = nbTills - nbTillsByType[type];
                        }
                        if (['BW_ESSENTIEL', 'BW_PREMIUM'].indexOf(type) !== -1 && nbTillsByType[type] !== 0){
                            amountBW += goodwillGesturesService.EXCEPTIONAL_OFFER[nbTillsByType[type]][contractType]['BW'];
                            nbTills = nbTills - nbTillsByType[type];
                        }
                        if (['ESSENTIEL', 'PREMIUM'].indexOf(type) !== -1 && nbTillsByType[type] !== 0)
                            amountBT += goodwillGesturesService.EXCEPTIONAL_OFFER[nbTillsByType[type]][contractType]['BT'];
                        if (['BS_ESSENTIEL', 'BS_PREMIUM'].indexOf(type) !== -1 && nbTillsByType[type] !== 0)
                            amountBS += goodwillGesturesService.EXCEPTIONAL_OFFER[nbTillsByType[type]][contractType]['BS'];
                        if (['BSW_ESSENTIEL', 'BSW_PREMIUM'].indexOf(type) !== -1 && nbTillsByType[type] !== 0)
                            amountBSW += goodwillGesturesService.EXCEPTIONAL_OFFER[nbTillsByType[type]][contractType]['BSW'];
                        if (type === 'BM' || type === 'BM+' && nbTillsByType[type] !== 0)
                            amountBM += goodwillGesturesService.EXCEPTIONAL_OFFER[nbTillsByType[type]][contractType]['BM'];

                    });
                    pallier = (amountBT + amountBS + amountBM + amountBG + amountBSW + amountBW) * 0.85;
                }
                let pricesTillAccessories = _calculatePricesTillAccessoriesForExceptionalOffer(nbTills);
                let pricesCashDrawers = _calculateCashDrawersPricesForExceptionalOffer(nbTills);
                let pricesTillSoftware = _calculatePricesTillSoftwaresForExceptionalOffer(nbTills);

                let subtotal = 0;
                subtotal += order.prices.till + pricesCashDrawers;
                subtotal += pricesTillSoftware + pricesTillAccessories;
                subtotal += order.prices.warrantyExtension;
                subtotal -= self.calculatePromotionsTotalAmount(order.prices.promotions);
                if (!_isRental() || (typeof order.installContractType !== 'undefined' && order.installContractType.code !== 'ACHAT')) {
                    subtotal += order.prices.prestationInstallation;
                }
                price = subtotal - pallier;
            }

            return price;
        }

        let _calculatePricesTillAccessoriesForExceptionalOffer = function (nbTills) {
            let totalPrice = 0;
            let scanner = _order.options.reduce((curr, opt) => {
                if(opt.code === 'SCANNER-GRYPHON' && !opt.refurbished)
                    curr.push(opt);
                return curr;
            },[]);

            const options = JSON.parse(JSON.stringify(_order.options));
            options.forEach(function (option) {
                var priceToAdd = option.prices.find(function (price) {
                    return (
                        price.type.code === _order.contract.contractType.code &&
                        price.marketType.code === _order.marketType.code
                    );
                }) || {value: 0};
                option.nbOptions = option.nbOptions > nbTills ? nbTills : option.nbOptions;
                if (option.optionType.code === 'ACCESSOIRE_CAISSE' && option.code === 'SCANNER-GRYPHON') {
                    if (!option.refurbished){
                        totalPrice += self.getTillAccessoriesPrice(
                            self.applyDegressiveRate(
                                priceToAdd.value,
                                self.getDegressiveRate(_order, option.nbOptions, true),
                                false,
                                false
                            ),
                            option.nbOptions
                        );
                    }else {
                        if((scanner.length && scanner[0].nbOptions < nbTills) || !scanner.length) {
                            totalPrice += self.getTillAccessoriesPrice(
                                self.applyDegressiveRate(
                                    priceToAdd.value,
                                    self.getDegressiveRate(_order, option.nbOptions, true),
                                    false,
                                    false
                                ),
                                option.nbOptions
                            );
                        }
                    }
                }


                if((tillPackService.hasBmoovPack(_order.tills) || tillPackService.hasBmoovPlusPack(_order.tills)) && option.optionType.code === 'ACCESSOIRE_CAISSE' && ['IMPRIMANTE-TICKET-RESEAU',
                    'DOCK-B-MOOV'].indexOf(option.code) !== -1){
                    totalPrice += self.getTillAccessoriesPrice(
                        self.applyDegressiveRate(
                            priceToAdd.value,
                            self.getDegressiveRate(_order, option.nbOptions, true),
                            false,
                            false
                        ),
                        option.nbOptions
                    );
                }
            });
            // console.log('accessoire ', totalPrice);
            return totalPrice;
        }

        let _calculatePricesTillSoftwaresForExceptionalOffer = function (nbTills) {
            let totalPrice = 0;
            const options = JSON.parse(JSON.stringify(_order.options));
            options.forEach(function (option) {
                var priceToAdd = option.prices.find(function (price) {
                    return (
                        price.type.code === _order.contract.contractType.code &&
                        price.marketType.code === _order.marketType.code
                    );
                }) || {value: 0};
                if (option.optionType.code === 'LOGICIEL_CAISSE' && (option.code === 'LOGICIEL_CAISSE_TABAC' || option.code === 'LOGICIEL_CAISSE_PRESSE'
                || option.code === 'LOGICIEL_CAISSE_ENCAISSEMENT')) {
                    totalPrice += self.applyDegressiveRate(
                        priceToAdd.value,
                        self.getDegressiveRate(_order, nbTills, true)
                    ) * nbTills;
                }
            });
            // console.log('logiciel ', totalPrice);
            return totalPrice;
        }

        let _calculateCashDrawersPricesForExceptionalOffer = function (nbTills) {
            let totalPrice = 0;
            let nbCashDrawers = 0;
            const cashDrawers = JSON.parse(JSON.stringify(_order.cashDrawers));
            for (let k = 0; k < cashDrawers.length; k++) {
                nbCashDrawers += cashDrawers[k].nbCashDrawers;
            }
            cashDrawers.sort(function compare(a, b) {
                if (self.getUnitPrice(
                    a.prices,
                    _order.contract.contractType.code,
                    _order.marketType.code
                ).value < self.getUnitPrice(
                    b.prices,
                    _order.contract.contractType.code,
                    _order.marketType.code
                ).value)
                    return -1;
                if (self.getUnitPrice(
                    a.prices,
                    _order.contract.contractType.code,
                    _order.marketType.code
                ).value > self.getUnitPrice(
                    b.prices,
                    _order.contract.contractType.code,
                    _order.marketType.code
                ).value)
                    return 1;
                return 0;
            });
            let cashDrawerUsed = 0;
            cashDrawers.forEach(function (cashDrawer) {
                var priceToAdd = self.getUnitPrice(
                    cashDrawer.prices,
                    _order.contract.contractType.code,
                    _order.marketType.code
                ) || {value: 0};
                cashDrawer.nbCashDrawers = cashDrawer.nbCashDrawers > nbTills ? nbTills : cashDrawer.nbCashDrawers;
                if(cashDrawerUsed < nbTills ){
                    if((tillPackService.hasBmoovPack(_order.tills) || tillPackService.hasBmoovPlusPack(_order.tills)) && !tillPackService.hasBtouchPack(_order.tills)
                        && !tillPackService.hasBsmartPack(_order.tills) && !tillPackService.hasBswiftPack(_order.tills)){
                        if(cashDrawer.label === 'Tiroir Standard C430 billets obliques' || cashDrawer.label === 'Tiroir Standard C430 billets à pinces')
                        {
                            cashDrawerUsed += cashDrawer.nbCashDrawers;
                            totalPrice +=
                                self.applyDegressiveRate(
                                    priceToAdd.value,
                                    self.getDegressiveRate(_order, cashDrawer.nbCashDrawers),
                                    false,
                                    !cashDrawer.refurbished
                                ) * cashDrawer.nbCashDrawers;
                        }
                    }else {
                        cashDrawerUsed += cashDrawer.nbCashDrawers;
                        totalPrice +=
                            self.applyDegressiveRate(
                                priceToAdd.value,
                                self.getDegressiveRate(_order, cashDrawer.nbCashDrawers),
                                false,
                                !cashDrawer.refurbished
                            ) * cashDrawer.nbCashDrawers;
                    }
                }


            });
            //console.log('tiroir ', totalPrice);
            return totalPrice;
        };

        self.calculateFullPremiumOffer = function () {
            let price = 0;
            if (_order.isFullPremiumOffer) {
                price = goodwillGesturesService.calculateFullPremiumOffer(_order);
            }
            return price;
        }

        self.calculateBgreenOffer = () => {
            let mixed = tillPackService.getTillsByTillCode(_orderForm, _order);
            return _order.isBgreenOffer ? goodwillGesturesService.calculateBgreenOffer(mixed.isMixed, mixed['BG_PREMIUM'].nbTills, mixed['BG_ESSENTIEL'].nbTills) : 0;
        }

        self.calculateQuickInstallOffer = () => {
            let mixed = tillPackService.getTillsByTillCode(_orderForm, _order);
            let modules = _order.options.filter(option => option.code === 'LOGICIEL_CAISSE_TABAC' || option.code === 'LOGICIEL_CAISSE_PRESSE');
            return _order.isQuickInstallOffer ? goodwillGesturesService.calculateQuickInstallOffer(mixed, _order.contract.contractType.code, modules, _order.dateCreated, _order.contract.scenarioType.code) : 0;
        }

        /* =========================================================================================== */
        /*                                      TILL OPTIONS                                           */
        /* =========================================================================================== */

        self.calculateGestionPrices = () => {
            let price = 0;
            _order.options.forEach(function (option) {
                if (option.optionType.code === 'GESTION') {
                    let priceToAdd = option.prices.find(function (price) {
                        return (
                            price.type.code === _order.contract.contractType.code &&
                            price.marketType.code === _order.marketType.code
                        );
                    }) || {value: 0};

                    price = priceToAdd.value;
                }
            })
            return price;
        }

        /**
         * Get the price for till options: optionType = LOGICIEL_CAISSE, ACCESSOIRE_CAISSE, SAV, MAINTENANCE,
         * EXTENSION, GESTION PACK_BOULANGERIE, SERVICE_LOGICIEL
         * @method calculateTillOptionsPrice
         * @return {Number} totalPrice
         */
        self.calculateTillOptionsPrices = function calculateTillOptionsPrices(tillAmount, tillOptionsList) {
            var totalPrice = {};
            tillOptionsList.forEach(function (value) {
                var key = value.toLowerCase();
                totalPrice[key] = 0;
            });

            _order.options.forEach(function (option) {
                if (tillOptionsList.indexOf(option.optionType.code) > -1) {
                    var priceToAdd = option.prices.find(function (price) {
                        if (
                            (option.optionType.code === 'MAINTENANCE' ||
                                option.optionType.code === 'SAV' ||
                                (option.optionType.code === 'EXTENSION' &&
                                    offerService.isOlderOffer(_order) === true)) &&
                            _order.contract.contractType.code === 'ACHAT'
                        ) {
                            return price.type.code === 'LOC48' && price.marketType.code === _order.marketType.code;
                        } else {
                            return (
                                price.type.code === _order.contract.contractType.code &&
                                price.marketType.code === _order.marketType.code
                            );
                        }
                    }) || {value: 0};

                    var tillDegressiveRate = self.getDegressiveRate(_order, tillAmount);

                    if (option.optionType.code === 'ACCESSOIRE_CAISSE') {
                        let round = !option.refurbished;
                        if (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET())) {
                            totalPrice[option.optionType.code.toLowerCase()] += self.getTillAccessoriesPrice(
                                self.applyDegressiveRate(
                                    priceToAdd.value,
                                    self.getDegressiveRate(_order, option.nbOptions, true),
                                    false,
                                    false
                                ),
                                option.nbOptions
                            );
                        } else {
                            totalPrice[option.optionType.code.toLowerCase()] += self.getTillAccessoriesPrice(
                                priceToAdd.value,
                                tillAmount
                            );
                        }
                    } else if (option.optionType.code === 'MAINTENANCE' || option.optionType.code === 'SAV') {
                        // MAINTENANCE hotline BT+ condition
                        if (
                            option.optionType.code === 'MAINTENANCE' &&
                            tillPackService.isBtouchPlusPack(_order.tills)
                        ) {
                            totalPrice[option.optionType.code.toLowerCase()] += 0;
                        } else {
                            // Round to 1 decimal condition
                            if (
                                offerService.isOlderOffer(_order) === false &&
                                (_isTRAD() || _isFLORAJET()) &&
                                option.optionType.code === 'MAINTENANCE'
                            ) {
                                totalPrice[option.optionType.code.toLowerCase()] +=
                                    self.applyDegressiveRate(priceToAdd.value * tillAmount, tillDegressiveRate, 1) *
                                    self.applyDiscountRate(option.discount || 0);
                            } else {
                                totalPrice[option.optionType.code.toLowerCase()] +=
                                    self.applyDegressiveRate(priceToAdd.value * tillAmount, tillDegressiveRate) *
                                    self.applyDiscountRate(option.discount || 0);
                            }
                        }
                    } else if (option.optionType.code === 'EXTENSION') {
                        totalPrice[option.optionType.code.toLowerCase()] +=
                            self.applyDegressiveRate(priceToAdd.value, tillDegressiveRate) * tillAmount;
                    } else if (option.optionType.code === 'GESTION') {
                        totalPrice[option.optionType.code.toLowerCase()] += priceToAdd.value;
                    } else if (option.optionType.code === 'GESTION_SCANUP') {
                        totalPrice[option.optionType.code.toLowerCase()] += priceToAdd.value;
                    } else if (option.optionType.code === 'SERVICE_LOGICIEL') {
                        var pack = boulangerieService.getPack(_order);
                        if (boulangerieService.check.premium(pack)) {
                            totalPrice[option.optionType.code.toLowerCase()] += 0;
                        } else if (boulangerieService.check.medium(pack)) {
                            totalPrice[option.optionType.code.toLowerCase()] += priceToAdd.value * option.nbOptions;
                        }
                    } else if (option.optionType.code === 'LOGICIEL_CAISSE') {
                        if (
                            marketService.isBoulangerieMarket(_order) &&
                            tillPackService.is2017TillPack(_order.tills, _order.orderType.code)
                        ) {
                            var pack = boulangerieService.getPack(_order);
                            // identical price no matter the pack for PRESSE software
                            if (option.label === 'PRESSE') {
                                totalPrice[option.optionType.code.toLowerCase()] += priceToAdd.value;
                            } else {
                                // Software modules offered in medium and premium packs
                                if (
                                    pack &&
                                    (boulangerieService.check.medium(pack) || boulangerieService.check.premium(pack))
                                ) {
                                    totalPrice[option.optionType.code.toLowerCase()] += 0;
                                } else {
                                    // if basic pack
                                    totalPrice[option.optionType.code.toLowerCase()] +=
                                        priceToAdd.value * tillAmount * self.applyDiscountRate(option.discount || 0);
                                }
                            }
                        } else {
                            // Default price rules for till software options
                            if (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET())) {
                                if (option.label === 'FLEURISTE' && _order.offer.code === 'materialTill') {
                                    totalPrice[
                                        option.optionType.code.toLowerCase()
                                        ] += _getMaterialTillFloristSoftwareModulePrice(option.label);
                                } else if (
                                    (/^RESTAURATION/.test(option.label) && option.label !== 'RESTAURATION seul') ||
                                    /^Pack MPDV/.test(option.label)
                                ) {
                                    totalPrice[option.optionType.code.toLowerCase()] += priceToAdd.value;
                                } else {
                                    totalPrice[option.optionType.code.toLowerCase()] +=
                                        self.applyDegressiveRate(
                                            priceToAdd.value,
                                            self.getDegressiveRate(_order, tillAmount, true)
                                        ) * tillAmount;
                                }
                            } else {
                                totalPrice[option.optionType.code.toLowerCase()] += self.applyDegressiveRate(
                                    priceToAdd.value * tillAmount,
                                    tillDegressiveRate
                                );
                            }
                        }
                    } else if (option.optionType.code === 'PACK_BOULANGERIE') {
                        totalPrice[option.optionType.code.toLowerCase()] += self.applyDegressiveRate(
                            priceToAdd.value * tillAmount,
                            tillDegressiveRate
                        );
                    } else {
                        // Default price rule price * tills amount
                        totalPrice[option.optionType.code.toLowerCase()] += priceToAdd.value * tillAmount;
                    }
                }
            });

            return totalPrice;
        };

        /**
         * Return total price for till software in case of a NAP order
         * @param  {Number} tillAmount till Amount
         * @return {Number} total price
         */
        self.calculateSoftwarePricesNAP = function calculateSoftwarePricesNAP(tillAmount) {
            var arrSoftware = _order.options.filter(function (option) {
                return option.optionType.code === 'LOGICIEL_CAISSE';
            });

            var arrSoftwareLength = arrSoftware.length;
            var softwarePrice = 0;

            if (arrSoftwareLength < 1 || _order.contract.contractType.code === null) {
                return 0;
            }

            for (var i = 0; i < arrSoftwareLength; i++) {
                softwarePrice =
                    softwarePrice + self.getUnitPrice(arrSoftware[i].prices, _order.contract.contractType.code).value;
            }

            return softwarePrice * tillAmount;
        };

        /**
         * Return total price for till accessories in case of a NAP order
         * @return {Number} total price
         */
        self.calculateTillAccessoriesPricesNAP = function calculateTillAccessoriesPricesNAP() {
            let tillAccessoriesOptions = _order.options.filter(function (option) {
                return option.optionType.code === 'ACCESSOIRE_CAISSE';
            });

            let totalPrice = 0;

            for (let option of tillAccessoriesOptions) {
                let unitPrice = self.getUnitPrice(
                    option.prices,
                    _order.contract.contractType.code,
                    _order.marketType.code
                ).value;
                totalPrice += unitPrice * option.nbOptions;
            }

            return {
                purchase: _isRental() ? 0 : totalPrice,
                rental: _isRental() ? totalPrice : 0
            };
        };

        /* =========================================================================================== */
        /*                                  MAINTENANCE PRICES                                         */
        /* =========================================================================================== */

        /**
         * Get the correct maintenance price value
         * @return {Number}
         */
        self.getMaintenancePrices = function getMaintenancePrices() {
            if (!_order.tills.length) {
                return 0;
            }

            // No maintenance price for BTouch tills (tillType BT or BT+) => priced with tillOptions
            if (tillPackService.is2017TillPack(_order.tills, _order.orderType.code)) {
                return 0;
            }

            var nbTotalTills = 0;
            var mdsValue = 0;

            for (var i = 0; i < _order.tills.length; i++) {
                nbTotalTills += _order.tills[i].nbTills;
            }

            // For extension scenario a unique price is defined
            if (_isExtensionScenario()) {
                nbTotalTills = _isNAP() ? _order.contract.nbTillsAdded : 0;
            }

            for (var j = 0; j < _orderForm.maintenancePrices.length; j++) {
                if (
                    _orderForm.maintenancePrices[j].orderType.code === _order.orderType.code &&
                    _orderForm.maintenancePrices[j].storeActivityCode === _order.client.storeActivityCode &&
                    ((_orderForm.maintenancePrices[j].isExtensionScenario &&
                            _isExtensionScenario() &&
                            (!_isNAP() || (_isNAP() && _orderForm.maintenancePrices[j].nbTills === nbTotalTills))) ||
                        (_orderForm.maintenancePrices[j].nbTills === nbTotalTills &&
                            !_orderForm.maintenancePrices[j].isExtensionScenario &&
                            !_isExtensionScenario()))
                ) {
                    return _orderForm.maintenancePrices[j].value;
                }
            }

            return 0;
        };

        /**
         * Get maintenance price
         * Pay attention : there is no maintenance for a purchase contract
         * @return {number}
         */
        self.calculateMaintenancePrices = function calculateMaintenancePrices() {
            var maintenancePrice = self.getMaintenancePrices();
            var monthlyMDS = self.calculateOfferedMaintenance(maintenancePrice);

            return maintenancePrice - monthlyMDS / self.getContractTypeValue();
        };

        /* =========================================================================================== */
        /*                                     REINTEGRATION                                           */
        /* =========================================================================================== */

        /**
         * Calculate the reintegration price
         * @return {Number}
         */
        self.calculateReintegrationPrices = function calculateReintegrationPrices() {
            if (_isNAP()) {
                return (
                    (_order.prices.proforma <= 10000 ? NAP_LEASER_REINTEGRATION_LOW : NAP_LEASER_REINTEGRATION_HIGH) *
                    _order.contract.nbMonths *
                    _order.contract.monthlyPayment
                );
            }

            return (
                (_order.contract.contractType.code === 'LOC48'
                    ? TRAD_LEASER_REINTEGRATION_LOC48
                    : _order.contract.contractType.code === 'LOC36'
                        ? TRAD_LEASER_REINTEGRATION_LOC36
                        : TRAD_LEASER_REINTEGRATION_LOC60) *
                _order.contract.nbMonths *
                _order.contract.monthlyPayment
            );
        };

        /* =========================================================================================== */
        /*                                       PRINTER                                               */

        /* =========================================================================================== */

        /**
         * Calculate printer prices
         * @param  {String} contractTypeCode
         * @return {Object} {
         *  supp, default
         * }
         */
        function _calculatePrinterPrices(contractTypeCode) {
            var price = {default: 0, supp: 0};

            for (var i = 0; i < _order.options.length; i++) {
                if (_order.options[i].optionType.code === 'IMPRIMANTE') {
                    for (var j = 0; j < _order.options[i].prices.length; j++) {
                        if (
                            _order.options[i].prices[j].type.code === contractTypeCode &&
                            _order.options[i].prices[j].marketType.code === _order.marketType.code &&
                            !_order.options[i].isAdditional
                        ) {
                            // TRAD
                            if (_isNAP() === false) {
                                if (offerService.isOlderOffer(_order) === true) {
                                    // Reduced prices for printers in BTouch +
                                    if (tillPackService.isBtouchPlusPack(_order.tills)) {
                                        if (_order.options[i].isDefault) {
                                            price.default = 0;
                                        } else if (
                                            marketService.isTabacPresseMarket(_order) ||
                                            marketService.isAutreMarket(_order)
                                        ) {
                                            price.default =
                                                (contractTypeCode === 'ACHAT'
                                                    ? 45
                                                    : contractTypeCode === 'LOC36'
                                                        ? 1.3
                                                        : 1) * _order.options[i].nbOptions; // prix spécifiques tillPack BT+ pour les imprimantes
                                        } else {
                                            price.default =
                                                _order.options[i].prices[j].value * _order.options[i].nbOptions;
                                        }
                                    } else {
                                        // BTouch and older tills prices
                                        if (tillPackService.is2017TillPack(_order.tills, _order.orderType.code)) {
                                            price.default = _order.options[i].prices[j].value * 1;
                                        } else {
                                            // Old printer prices
                                            if (_order.options[i].isDefault) {
                                                price.default = contractTypeCode === 'ACHAT' ? 39 : 1;
                                            } else if (_order.options[i].prices[j].value !== 0) {
                                                // There is a price for this printer
                                                price.default = contractTypeCode === 'ACHAT' ? 199 : 4;
                                            } else {
                                                // No printer
                                                price.default = 0;
                                            }
                                        }
                                    }
                                    // 2018 Offer
                                } else {
                                    price.default +=
                                        self.applyDegressiveRate(
                                            _order.options[i].prices[j].value,
                                            self.getDegressiveRate(_order, _order.options[i].nbOptions)
                                        ) * _order.options[i].nbOptions;
                                }
                                // NAP
                            } else {
                                price.default += _order.options[i].prices[j].value * _order.options[i].nbOptions;
                            }
                        }
                    }
                }
            }

            return price;
        }

        /**
         * Calculate the printer prices for TRAD network
         * @return {Object}
         */
        self.calculatePrinterPricesTRAD = function calculatePrinterPricesTRAD() {
            return _calculatePrinterPrices(_order.contract.contractType.code);
        };

        /**
         * Calculate the printer prices for NAP network
         * @return {Object} {purchase: price, rental: price}
         */
        self.calculatePrinterPricesNAP = function calculatePrinterPricesNAP() {
            return {
                purchase: _calculatePrinterPrices('ACHAT'),
                rental: _calculatePrinterPrices(_order.contract.contractType.code)
            };
        };

        /* =========================================================================================== */
        /*                                        SCANUP                                               */
        /* =========================================================================================== */

        /**
         * calculate the scanup prices: scanup devices (with installation price if option is present) and scanup options
         * @param  {String} contractTypeCode
         * @return {Object}
         */
        self.calculateScanupPrices = function calculateScanupPrices(contractTypeCode) {
            var price = {devices: 0, options: 0, moneyTransferOptions: 0, bimediaPayOptions: 0, softwares: 0};

            for (var i = 0; i < _order.options.length; i++) {
                if (_order.options[i].optionType.code === 'SCANUP' && _order.options[i].isScanupDevice) {
                    price.devices = self.calculateScanupSubPrices(price.devices, i, contractTypeCode);
                }
                if (
                    _order.options[i].optionType.code === 'SCANUP' &&
                    _order.options[i].code !== 'SOFT-SCANUP-PAIEMENT' &&
                    !_order.options[i].isScanupDevice
                ) {
                    price.options = self.calculateScanupSubPrices(price.options, i, contractTypeCode);
                }
                if (_order.options[i].code === 'SOFT-SCANUP-TABACPRESSE'
                    || _order.options[i].code === 'SOFT-SCANUP-TABAC'
                    || _order.options[i].code === 'SOFT-SCANUP-PRESSE') {
                    price.moneyTransferOptions += self.calculateScanupSubPrices(
                        price.moneyTransferOptions,
                        i,
                        contractTypeCode
                    );
                }
                if (_order.options[i].code === 'SOFT-SCANUP-PAIEMENT') {
                    price.bimediaPayOptions += self.calculateScanupSubPrices(
                        price.bimediaPayOptions,
                        i,
                        contractTypeCode
                    );
                }
                if ((_order.options[i].code === 'SOFT-SCANUP-TABACPRESSE'
                    || _order.options[i].code === 'SOFT-SCANUP-TABAC'
                    || _order.options[i].code === 'SOFT-SCANUP-PRESSE'
                    || _order.options[i].code === 'SOFT-SCANUP-ENCAISSEMENT')
                    && !_order.options[i].isScanupDevice) {
                    price.softwares = self.calculateScanupSubPrices(
                        price.softwares,
                        i,
                        contractTypeCode
                    );
                }
            }
            return price;
        };

        self.calculateScanupSubPrices = function calculateScanupSubPrices(totalPrices, i, contractTypeCode) {
            for (var j = 0; j < _order.options[i].prices.length; j++) {
                if (_order.options[i].code !== 'SOFT-SCANUP-PAIEMENT') {
                    if (
                        (_isNAP() && _order.options[i].prices[j].type.code === contractTypeCode) ||
                        (!_isNAP() &&
                            _order.options[i].contractType.code === _order.options[i].prices[j].type.code &&
                            _order.options[i].prices[j].marketType.code === _order.marketType.code)
                    ) {
                        _isScanupRental = _order.options[i].contractType.code !== 'ACHAT';
                        if (
                            offerService.isOlderOffer(_order) === false &&
                            (_isTRAD() || _isFLORAJET()) &&
                            _order.options[i].code !== 'SOFT-SCANUP-PAIEMENT'
                        ) {
                            totalPrices +=
                                self.applyDegressiveRate(
                                    _order.options[i].prices[j].value,
                                    self.getDegressiveRate(_order, _order.options[i].nbOptions),
                                    2,
                                    _order.options[i].code !== 'HOUSSE-SCANUP'
                                ) * _order.options[i].nbOptions;
                        } else {
                            totalPrices += _order.options[i].prices[j].value * _order.options[i].nbOptions;
                        }
                    }
                } else {
                    totalPrices =
                        self.applyDegressiveRate(
                            _order.options[i].prices[j].value,
                            self.getDegressiveRate(_order, _order.options[i].nbOptions),
                            2
                        ) * _order.options[i].nbOptions;
                }
            }
            return totalPrices;
        };

        /**
         * Calculate the scanup prices for NAP order
         * @return {Object} {
         *   purchase,
         *   rental
         * }
         */
        self.calculateScanupPricesNAP = function calculateScanupPricesNAP() {
            var prices = self.calculateScanupPrices(_order.contract.contractType.code);
            return {
                devices: {
                    purchase: _isRental() ? 0 : prices.devices,
                    rental: _isRental() ? prices.devices : 0
                },
                options: {
                    purchase: _isRental() ? 0 : prices.options,
                    rental: _isRental() ? prices.options : 0
                },
                softwares : {
                    purchase: _isRental() ? 0 : prices.softwares,
                    rental: _isRental() ? prices.softwares : 0
                }
            };
        };

        /* =========================================================================================== */
        /*                                        PRESTATIONS                                          */
        /* =========================================================================================== */
        /**
         * calculate the prestations prices
         * @param  {String} contractTypeCode
         * @return {Object}
         */
        self.calculatePrestationsPrices = function (contractTypeCode) {
            let price = {install: 0, cateringSupport: 0};

            for (let i = 0; i < _order.options.length; i++) {
                if (_order.options[i].optionType.code === 'PRESTATION') {
                    if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(_order.options[i].code)) {
                        price.install = self.calculatePrestationsSubPrices(price.install, i, contractTypeCode);
                    }
                    if (_isCateringSupport(_order.options[i].code)) {
                        price.cateringSupport = self.calculatePrestationsSubPrices(price.cateringSupport, i, contractTypeCode);
                    }
                }
            }
            return price;
        };

        self.calculatePrestationsSubPrices = function (totalPrices, i, contractTypeCode) {
            let tillAmount = _order.options[i].isDependNbTills ? orderService.getNbTills(_order.tills) : 1;
            for (let j = 0; j < _order.options[i].prices.length; j++) {
                if (
                    (_isNAP() && _order.options[i].prices[j].type.code === contractTypeCode && _order.options[i].prices[j].nbTills === tillAmount) ||
                    (!_isNAP() &&
                        _order.options[i].contractType.code === _order.options[i].prices[j].type.code &&
                        _order.options[i].prices[j].marketType.code === _order.marketType.code &&
                        _order.options[i].prices[j].nbTills === tillAmount)
                ) {
                    if (
                        offerService.isOlderOffer(_order) === false
                    ) {
                        if (_isCateringSupport(_order.options[i].code) && (_isTRAD() || _isFLORAJET())) {
                            _isCateringSupportRental = _order.options[i].contractType.code !== 'ACHAT';
                        }
                        if (['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO', 'INSTALLATION-SITE-PERIPHERIQUE'].includes(_order.options[i].code)) {
                            _isInstallRental = _order.options[i].contractType.code !== 'ACHAT';
                        }
                    }

                    totalPrices +=
                        self.applyDegressiveRate(
                            _order.options[i].prices[j].value,
                            self.getDegressiveRate(_order, _order.options[i].nbOptions),
                            false,
                            false
                        ) * _order.options[i].nbOptions;


                }
            }
            return totalPrices;
        };


        /* =========================================================================================== */
        /*                                        FLASHUP                                               */
        /* =========================================================================================== */

        self.calculateFlashupPrices = function calculateFlashupPrices() {
            var price = 0;
            for (var i = 0; i < _order.options.length; i++) {
                if (_order.options[i].optionType.code === 'FLASHUP') {
                    _isFlashupRental = _order.options[i].contractType.code !== 'ACHAT';
                    for (var j = 0; j < _order.options[i].prices.length; j++) {
                        if (
                            _order.options[i].prices[j].type.code === _order.options[i].contractType.code &&
                            _order.options[i].prices[j].marketType.code === _order.marketType.code
                        ) {
                            // Flashup prices are stored in the prices.value array and are ordered by price from the lowest to the highest
                            price += _order.options[i].prices[j].value[_order.options[i].nbOptions - 1];
                        }
                    }
                }
            }
            return price;
        };

        /* =========================================================================================== */
        /*                                    DEFAULT OPTION                                           */

        /* =========================================================================================== */
        /**
         * calculate the default options prices (PC and tablet)
         * @param  {String} contractTypeCode
         * @return {Number}
         */
        function _calculateDefaultOptionsPrices(contractTypeCode) {
            var price = 0;

            for (var i = 0; i < _order.options.length; i++) {
                if (_order.options[i].optionType.code === 'DEFAUT') {
                    for (var j = 0; j < _order.options[i].prices.length; j++) {
                        if (
                            _order.options[i].prices[j].type.code === contractTypeCode &&
                            _order.options[i].prices[j].marketType.code === _order.marketType.code
                        ) {
                            if ((_isTRAD() || _isFLORAJET()) && offerService.isOlderOffer(_order) === false) {
                                price +=
                                    self.applyDegressiveRate(
                                        _order.options[i].prices[j].value,
                                        self.getDegressiveRate(_order, _order.options[i].nbOptions, true)
                                    ) * _order.options[i].nbOptions;
                            } else {
                                price += _order.options[i].prices[j].value * _order.options[i].nbOptions;
                            }
                        }
                    }
                }
            }

            return price;
        }

        /**
         * calculate the default options prices (PC and tablet) for TRAD order
         * @return {Number}
         */
        self.calculateDefaultOptionsPricesTRAD = function calculateDefaultOptionsPricesTRAD() {
            return _calculateDefaultOptionsPrices(_order.contract.contractType.code);
        };

        /**
         * calculate the default options prices (PC and tablet) for NAP order
         * @return {Number}
         */
        self.calculateDefaultOptionsPricesNAP = function calculateDefaultOptionsPricesNAP() {
            return {
                purchase: _isRental() ? 0 : _calculateDefaultOptionsPrices('ACHAT'),
                rental: _isRental() ? _calculateDefaultOptionsPrices(_order.contract.contractType.code) : 0
            };
        };

        /* =========================================================================================== */
        /*                                          TPE                                                */
        /* =========================================================================================== */

        /**
         * Calculate TPE price value
         * @method calculateTPEPrices
         * @return {Number}           price
         */
        self.calculateTPEPrices = function calculateTPEPrices() {
            var price = 0;
            var contractMonths = orderService.getContractMonths(_order);

            for (var i = 0; i < _order.options.length; i++) {
                if (_order.options[i].isTPEDevice && _order.options[i].nbOptions > 0) {
                    for (var j = 0; j < _order.options[i].prices.length; j++) {
                        if (
                            _order.options[i].prices[j].type.code === 'LOC' + contractMonths &&
                            _order.options[i].prices[j].marketType.code === _order.marketType.code
                        ) {
                            var discountRate = self.applyDiscountRate(_order.options[i].discount || 0);
                            price += _order.options[i].prices[j].value * _order.options[i].nbOptions * discountRate;
                        }
                    }
                }
            }

            return price;
        };

        /**
         * Calculate TPE options prices (all priced as purchase, or is an exception listed in napService)
         * All the tpe options can only be purchased
         * @return {Number}
         */
        self.calculateTPEOptionsPrices = function calculateTPEOptionsPrices() {
            var price = {rental: 0, purchase: 0};

            for (var i = 0; i < _order.options.length; i++) {
                if (_order.options[i].optionType.code === 'TPE' || _order.options[i].optionType.code === 'LOGICIEL') {
                    for (var j = 0; j < _order.options[i].prices.length; j++) {
                        if (_isNAP()) {
                            // TPE options exceptions for NAP : priced for rental
                            if (
                                napService.isTpeOptionException(_order.options[i].reference) &&
                                _order.options[i].prices[j].type.code === _order.contract.contractType.code
                            ) {
                                price.rental += _order.options[i].prices[j].value * _order.options[i].nbOptions;
                            }
                            if (
                                napService.isTpeOptionException(_order.options[i].reference) === false &&
                                _order.options[i].prices[j].type.code === 'ACHAT'
                            ) {
                                price.purchase += _order.options[i].prices[j].value * _order.options[i].nbOptions;
                            }
                        } else {
                            // Other options are priced for purchase
                            if (
                                _order.options[i].prices[j].type.code === 'ACHAT' &&
                                _order.options[i].prices[j].marketType.code === _order.marketType.code
                            ) {
                                price.purchase += _order.options[i].prices[j].value * _order.options[i].nbOptions;
                            }
                        }
                    }
                }
            }

            return price;
        };

        self.calculateTPEPricesNAP = function calculateTPEPricesNAP() {
            var pricesDevices = self.calculateTPEPrices();
            var pricesOptions = self.calculateTPEOptionsPrices();
            return {
                purchase: pricesOptions.purchase,
                rental: pricesDevices + pricesOptions.rental
            };
        };

        /* =========================================================================================== */
        /*                                    BIMEDIA PAY OPTION                                       */
        /* =========================================================================================== */

        self.calculateBimediaPayDiscount = function () {
            if (_order.goodwillGestures && _order.goodwillGestures.amount.launchBimediaPay) {
                _order.goodwillGestures.amount.launchBimediaPay = self.calculateLaunchBimediaPayTotal();
                goodwillGesturesService.LAUNCH_BIMEDIA_PAY_MONTHLY_AMOUNT = self.LAUNCH_BIMEDIA_PAY_MONTHLY_AMOUNT;
                return self.LAUNCH_BIMEDIA_PAY_MONTHLY_AMOUNT;
            }
            return 0;
        };

        self.calculateLaunchBimediaPayTotal = function calculateLaunchBimediaPayTotal() {
            let option = _order.options.filter(opt => opt.code === 'SOFT-SCANUP-ENCAISSEMENT');
            self.LAUNCH_BIMEDIA_PAY_MONTHLY_AMOUNT = self.getOptionUnitPrice(option[0]) * 0.25 * option[0].nbOptions;
            self.LAUNCH_BIMEDIA_PAY_NUMBER_OF_MONTHS =
                option[0].contractType.code === 'LOC24'
                    ? 24
                    : option[0].contractType.code === 'LOC36'
                        ? 36
                        : option[0].contractType.code === 'LOC48'
                            ? 48
                            : option[0].contractType.code === 'LOC60'
                                ? 60
                                : 1;
            goodwillGesturesService.LAUNCH_BIMEDIA_PAY_NUMBER_OF_MONTHS = self.LAUNCH_BIMEDIA_PAY_NUMBER_OF_MONTHS;
            return (
                self.LAUNCH_BIMEDIA_PAY_MONTHLY_AMOUNT * self.LAUNCH_BIMEDIA_PAY_NUMBER_OF_MONTHS +
                _order.prices.scanupBimediaPayOptions * 12
            ); // + 12 mois offert
        };

        /* =========================================================================================== */
        /*                                    B BOOSTER OPTION                                         */
        /* =========================================================================================== */

        self.calculateBBoosterPrices = function () {
            let price = {rental: 0, purchase: 0};

            for (let i = 0; i < _order.options.length; i++) {
                if (_order.options[i].optionType.code === 'OPTSANSENG') {
                    for (let j = 0; j < _order.options[i].prices.length; j++) {
                        if (
                            _order.options[i].prices[j].type.code === 'ACHAT' &&
                            _order.options[i].prices[j].marketType.code === _order.marketType.code &&
                            _order.options[i].code === 'B-BOOSTER'
                        ) {
                            price.purchase += _order.options[i].prices[j].value * _order.options[i].nbOptions *
                                self.applyDiscountRate(_order.options[i].discount || 0);
                        }
                        if (
                            _order.options[i].prices[j].type.code === _order.contract.contractType.code &&
                            _order.options[i].prices[j].marketType.code === _order.marketType.code &&
                            _order.options[i].code === 'PACK-B-BOOSTER'
                        ) {
                            price.rental += _order.options[i].prices[j].value * _order.options[i].nbOptions *
                                self.applyDiscountRate(_order.options[i].discount || 0);
                        }
                    }
                }
            }
            return price;
        };

        /* =========================================================================================== */
        /*                                    NAP SERVICES                                           */
        /* =========================================================================================== */
        /**
         * Calculate the NAP services prices
         * @return {Number}
         */
        self.calculateDefaulNAPServicesPrices = function calculateDefaulNAPServicesPrices() {
            var price = 0;

            for (var i = 0; i < _order.options.length; i++) {
                if (_order.options[i].optionType.code === 'NAP') {
                    for (var j = 0; j < _order.options[i].prices.length; j++) {
                        if (_order.options[i].prices[j].type.code === 'ACHAT') {
                            price += _order.options[i].prices[j].value;
                        }
                    }
                }
            }

            return price;
        };

        /* =========================================================================================== */
        /*                                      INSURANCE                                              */
        /* =========================================================================================== */

        /**
         * Find base insurance prices in the orderForm according to the given orderType and tills amount
         * @param  {String} type   orderType
         * @param  {Number} nbTills amount of tills
         * @return {Number}  unit price for insurance
         */
        self.getInsuranceUnitPrice = function getInsuranceUnitPrice(type, nbTills) {
            var price = 0;

            if (nbTills > 0 && nbTills <= 6) {
                var warrantyPrice = _orderForm.warrantyPrices.find(function (price) {
                    return price.orderType === type;
                });

                price = warrantyPrice ? warrantyPrice.value : 0;
            }

            return price;
        };

        /**
         * Get the insurances prices with the given network
         * @param {Array} prices
         * @param {Object} order
         */
        self.getInsuranceValidPricesByOrder = function (prices, order) {
            return prices.find(function (priceToFilter) {
                return (
                    commonService.isInDateRange(
                        order.dateCreated,
                        priceToFilter.minDateValidity,
                        priceToFilter.maxDateValidity
                    ) && priceToFilter.orderType.code === order.orderType.code
                    && priceToFilter.nbTills === -1
                );
            });
        };

        /**
         * calculate insurance prices
         * @return {Number}
         */
        self.calculateInsurancePrices = function calculateInsurancePrices() {
            if ((!_isNAP() && !_order.contract.isMudetaf) || marketService.isBoulangerieMarket(_order)) {
                return 0;
            }

            var price = 0;
            var nbTills = orderService.getNbTills(_order.tills);

            if (nbTills === 0) {
                return price;
            }

            price = self.getInsuranceValidPricesByOrder(_orderForm.warrantyPrices, _order).value * nbTills;

            return price;
        };

        /* =========================================================================================== */
        /*                                       PROFORMA                                              */
        /* =========================================================================================== */

        /**
         * Calculate proforma Price
         * Total = fidelity offer + scanup + pc + reintegration + repeater + printer + tills // Ancienne offre 2016
         * Till  + software + till accessories + cashdrawers + scanup + repeater + printer + pc + reintegration --> ((monthly price / leasing rate) or purchase price)// Offre 2017
         * @return {Object}
         */
        self.calculateProformaTotalPrice = function calculateProformaTotalPrice() {
            var total = 0;
            var leaserRate = _isRental() ? self.getLeaserRate() : 1;

            // 2017 TRAD and NAP offers
            if (
                tillPackService.is2017TillPack(_order.tills, _order.orderType.code) ||
                (_isNAP() && offerService.isOlderOffer(_order) === false)
            ) {
                // Filter the concerned options
                var optionsProformaPrice = _order.options
                    .filter(function (option) {
                        return (
                            (option.optionType.code === 'SCANUP' &&
                                !option.isService &&
                                option.code !== 'SOFT-SCANUP-PAIEMENT') ||
                            option.optionType.code === 'DEFAUT' ||
                            option.optionType.code === 'IMPRIMANTE'
                        );
                    })
                    // Find the right price value in each option
                    .map(function (option) {
                        return (
                            (
                                option.prices.find(function (price) {
                                    return (
                                        price.type.code == _order.contract.contractType.code &&
                                        price.marketType.code === _order.marketType.code
                                    );
                                }) || {value: 0}
                            ).value * option.nbOptions
                        );
                    })
                    .reduce(function (prevPrice, nextPrice) {
                        return prevPrice + (nextPrice / leaserRate);
                    }, 0);

                // Scanup, Defaut and printer options
                _order.prices.proformaDetails.options = optionsProformaPrice ;
                total += _order.prices.proformaDetails.options;

                // Till + software + cashdrawer
                _order.prices.proformaDetails.till = _order.prices.till / leaserRate;
                _order.prices.proformaDetails.software =
                    (_order.prices.tillSoftware + _order.prices.softwareServices) / leaserRate;
                _order.prices.proformaDetails.cashDrawers = _order.prices.cashDrawers / leaserRate;
                total +=
                    (_order.prices.proformaDetails.till +
                        _order.prices.proformaDetails.software +
                        _order.prices.proformaDetails.cashDrawers);

                // Promotions
                _order.prices.proformaDetails.promotions =
                    self.calculatePromotionsTotalAmount(_order.prices.promotions) / leaserRate;
                total -= _order.prices.proformaDetails.promotions;

                // Till accessories
                _order.prices.proformaDetails.tillAccessories = _order.prices.tillAccessories / leaserRate;
                total += _order.prices.tillAccessories / leaserRate;

                //prestations
                _order.prices.proformaDetails.prestations = _order.prices.prestationInstallation /leaserRate;
                total += _order.prices.proformaDetails.prestations;
            } else if (_isNAP() && offerService.isOlderOffer(_order) === true) {
                total += _isNAP() ? self.calculateTillPricesNAP().purchase : self.calculateTillPricesTRAD('ACHAT');
                for (var i = 0; i < _order.options.length; i++) {
                    // Printer
                    if (_order.options[i].optionType.code === 'IMPRIMANTE') {
                        for (var j = 0; j < _order.options[i].prices.length; j++) {
                            if (_order.options[i].prices[j].type.code === 'PROFORMA') {
                                if (!_isNAP() || (_isNAP() && !_order.options[i].isDefault)) {
                                    total += _order.options[i].prices[j].value;
                                }

                                if (_isNAP() && !_order.options[i].isDefault && _order.options[i].prices[j].value) {
                                    total += 46;
                                }
                                break;
                            }
                        }
                    }

                    // Scanup and Defaut options (except scanup installation)
                    if (
                        (_order.options[i].optionType.code === 'SCANUP' &&
                            !_order.options[i].isService &&
                            _order.option[i].code !== 'SOFT-SCANUP-PAIEMENT') ||
                        _order.options[i].optionType.code === 'DEFAUT'
                    ) {
                        for (var j = 0; j < _order.options[i].prices.length; j++) {
                            if (_order.options[i].prices[j].type.code === 'ACHAT') {
                                total += _order.options[i].prices[j].value * _order.options[i].nbOptions;
                                break;
                            }
                        }
                    }
                }
                // Fidelity --> seulement appliquée au calcul proforma sur les anciennes offres.
                if (_order.contract.nbMonthsFidelity && _order.contract.monthlyPaymentFidelity) {
                    total += _order.contract.nbMonthsFidelity * _order.contract.monthlyPaymentFidelity;
                }
                //prestations
                _order.prices.proformaDetails.prestations = _order.prices.prestationInstallation /leaserRate;
                total += _order.prices.proformaDetails.prestations;
            }

            // 2018 TRAD Offer
            if (offerService.isOlderOffer(_order) === false && (_isTRAD() || _isFLORAJET())) {
                // Filter the concerned options
                var optionsProformaPrices = _order.options
                    .filter(function (option) {
                        return (
                            (option.optionType.code === 'SCANUP' &&
                                !option.isService &&
                                option.code !== 'SOFT-SCANUP-PAIEMENT') ||
                            option.optionType.code === 'DEFAUT' || option.optionType.code === 'IMPRIMANTE'
                        );
                    })
                    // Find the right price value in each option
                    .map(function (option) {
                        // let priceNbTills = option.isDependNbTills ? nbTills : 1;
                        return (
                            self.applyDegressiveRate(
                                // self.getOptionUnitPriceByTills(option.prices, _order.contract.contractType.code, _order.marketType.code, priceNbTills).value || 0,
                                self.getUnitPrice(
                                    option.prices,
                                    _order.contract.contractType.code,
                                    _order.marketType.code
                                ).value || 0,
                                self.getDegressiveRate(_order, option.nbOptions),
                                2,
                                false
                            ) * option.nbOptions
                        );
                    });

                // Till + software + cashdrawer
                _order.prices.proformaDetails.till = _order.prices.till / leaserRate;
                _order.prices.proformaDetails.cashDrawers = _order.prices.cashDrawers / leaserRate;
                _order.prices.proformaDetails.software = (_order.prices.tillSoftware + _order.prices.softwareServices) / leaserRate;
                total +=
                    (_order.prices.proformaDetails.till +
                        _order.prices.proformaDetails.software +
                        _order.prices.proformaDetails.cashDrawers);
                // Promotions
                _order.prices.proformaDetails.promotions =
                    self.calculatePromotionsTotalAmount(_order.prices.promotions) / leaserRate;
                total -= _order.prices.proformaDetails.promotions;

                // Till accessories
                _order.prices.proformaDetails.tillAccessories = _order.prices.tillAccessories / leaserRate;
                total += _order.prices.tillAccessories / leaserRate;

                // Options
                _order.prices.proformaDetails.options = self.sumPrices(optionsProformaPrices, 0) / leaserRate;
                total += _order.prices.proformaDetails.options;

                //prestations
                _order.prices.proformaDetails.prestations = _order.prices.prestationInstallation /leaserRate;
                total += _order.prices.proformaDetails.prestations;

                // goodwillGestures
                _order.prices.proformaDetails.goodwillGestures = (_order.prices.scanupBimediaPayDiscount / leaserRate
                    + _order.prices.exceptionalOffer / leaserRate
                    + _order.prices.fullPremiumOffer / leaserRate
                    + _order.prices.quickInstallOffer / leaserRate);
                total -= _order.prices.proformaDetails.goodwillGestures;
            }

            return total;
        };

        /* =========================================================================================== */
        /*                                       DELOITTE                                              */
        /* =========================================================================================== */

        /**
         * Calcul de l'estimation de la subvention Deloitte
         * @returns {number}
         */
        self.calculateDeloitte = function calculateDeloitte() {
            var presseSoftwarePrice = _getOptionPriceByCode('LOGICIEL_CAISSE_PRESSE');
            var tabacSoftwarePrice = _getOptionPriceByCode('LOGICIEL_CAISSE_TABAC');
            var computerPrice = _getOptionPriceByCode('PC-PORTABLE-GESTION');
            let librairiePrice = _getOptionPriceByCode('LOGICIEL_CAISSE_LIBRAIRIE');
            let fleuristePrice = _getOptionPriceByCode('LOGICIEL_CAISSE_FLEURISTE');
            let boulangeriePrice = _getOptionPriceByCode('LOGICIEL_CAISSE_BOULANGERIE');
            let restaurationCouplePrice = _getOptionPriceByCode('RESTAURATION-COUPLE');
            let restaurationSeulPrice = _getOptionPriceByCode('RESTAURATION-SEUL');
            let mpdvPilotage = _getOptionPriceByCode('PACK-MPDV-PILOTAGE');
            var total = _order.prices.proforma;
            var proportion = _isOnlyPresse() ? 1 : 0.75;

            let totalModules = presseSoftwarePrice + tabacSoftwarePrice + computerPrice + librairiePrice
                + fleuristePrice + boulangeriePrice + restaurationCouplePrice + restaurationSeulPrice + mpdvPilotage;
            var amount75Percent = (total - totalModules) * proportion;
            var amountTotal = amount75Percent + computerPrice + presseSoftwarePrice;

            return amountTotal * DELOITTE_PERCENT_SUBVENTION > DELOITTE_MAX_AMOUNT
                ? DELOITTE_MAX_AMOUNT
                : amountTotal * DELOITTE_PERCENT_SUBVENTION;
        };

        /**
         * Les options du bon de commande sont filtrées par leur code, est retournée la somme des prix des options ayant le
         * code passé en paramètre
         * @param code
         * @returns {number}
         * @private
         */
        function _getOptionPriceByCode(code) {
            var result = 0;
            var orderOptionLength = _order.options.length;
            var nbTills = orderService.getNbTills(_order.tills);
            var leaserRate = _isRental() ? self.getLeaserRate() : 1;

            for (var i = 0; i < orderOptionLength; i++) {
                if (_order.options[i].code === code) {
                    result =
                        result +
                        (self.applyDegressiveRate(
                                self.getUnitPrice(
                                    _order.options[i].prices,
                                    _order.contract.contractType.code,
                                    _order.marketType.code
                                ).value,
                                self.getDegressiveRate(_order, nbTills, true),
                                0
                            ) *
                            nbTills) /
                        leaserRate;
                }
            }

            return result;
        }

        function _isOnlyPresse() {
            var only = true;
            _order.options
                .filter(option => option.optionType.code === 'LOGICIEL_CAISSE')
                .forEach(software => {
                    if (software.label !== 'ENCAISSEMENT' && software.label !== 'PRESSE') {
                        only = false;
                    }
                });

            return only;
        }

        /* =========================================================================================== */
        /*                                       MARGIN                                                */
        /* =========================================================================================== */

        /**
         * Calculate order's margin. Formula: purchase till price - till cost - generosity (maintenance, reprise, TPE, PC (+ prime bienvenue ?))
         * @param  {Object} order
         * @return {Number}       total margin on the order
         */
        self.calculateMargin = function calculateMargin(order) {
            if (orderService.getNbTills(order.tills) === 0) {
                return 0;
            }

            var softwareType = '';
            var softwares = order.options.filter(function (option) {
                return option.optionType.code === 'LOGICIEL_CAISSE';
            });

            if (softwares.length === 0) {
                return 0;
            } else if (softwares.length === 2) {
                softwareType = 'TABACPRESSE';
            } else if (softwares.length === 1) {
                softwareType = softwares[0].label;
            }

            var margin = marginService.getMargin(order.tills, softwareType);

            // Generosity
            var generosity = 0;
            if (_order.goodwillGestures) {
                generosity = Object.keys(_order.goodwillGestures.amount)
                    .filter(function (key) {
                        return (
                            key === 'mds' || key === 'tillPartExchange' || key === 'tpe' || key === 'scanupPartExchange'
                        );
                    })
                    .map(function (key) {
                        return _order.goodwillGestures.amount[key];
                    })
                    .reduce(function (acc, amount) {
                        return acc + amount;
                    }, 0);
            }

            if (_order.drvBudget) {
                var budgetOption = _orderForm.options.find(function (option) {
                    return option.id === _order.drvBudget.option_id;
                });
                var price = budgetOption.prices.find(function (price) {
                    return price.type.code === 'ACHAT' && price.marketType.code === _order.marketType.code;
                });
                generosity += price.value;
            }

            return margin - generosity;
        };

        return self;
    }

    PricesService.$inject = [
        '$rootScope',
        '$log',
        'orderService',
        'marketService',
        'tillPackService',
        'boulangerieService',
        'goodwillGesturesService',
        'marginService',
        'napService',
        'offerService',
        'promotionService',
        'commonService'
    ];

    angular.module('app.bdc.list.pricesService', []).factory('pricesService', PricesService);
});
